// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface IACDCode {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class ACDCode implements IACDCode, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns A04 ACDCode
	**/
    get A04(): IACDCode {
        return this.FromId(1);
    }
    /**
		Returns A08 ACDCode
	**/
    get A08(): IACDCode {
        return this.FromId(2);
    }
    /**
		Returns A10 ACDCode
	**/
    get A10(): IACDCode {
        return this.FromId(3);
    }
    /**
		Returns A11 ACDCode
	**/
    get A11(): IACDCode {
        return this.FromId(4);
    }
    /**
		Returns A12 ACDCode
	**/
    get A12(): IACDCode {
        return this.FromId(5);
    }
    /**
		Returns A20 ACDCode
	**/
    get A20(): IACDCode {
        return this.FromId(6);
    }
    /**
		Returns A21 ACDCode
	**/
    get A21(): IACDCode {
        return this.FromId(7);
    }
    /**
		Returns A22 ACDCode
	**/
    get A22(): IACDCode {
        return this.FromId(8);
    }
    /**
		Returns A23 ACDCode
	**/
    get A23(): IACDCode {
        return this.FromId(9);
    }
    /**
		Returns A24 ACDCode
	**/
    get A24(): IACDCode {
        return this.FromId(10);
    }
    /**
		Returns A25 ACDCode
	**/
    get A25(): IACDCode {
        return this.FromId(11);
    }
    /**
		Returns A26 ACDCode
	**/
    get A26(): IACDCode {
        return this.FromId(12);
    }
    /**
		Returns A27 ACDCode
	**/
    get A27(): IACDCode {
        return this.FromId(13);
    }
    /**
		Returns A30 ACDCode
	**/
    get A30(): IACDCode {
        return this.FromId(14);
    }
    /**
		Returns A31 ACDCode
	**/
    get A31(): IACDCode {
        return this.FromId(15);
    }
    /**
		Returns A32 ACDCode
	**/
    get A32(): IACDCode {
        return this.FromId(16);
    }
    /**
		Returns A33 ACDCode
	**/
    get A33(): IACDCode {
        return this.FromId(17);
    }
    /**
		Returns A34 ACDCode
	**/
    get A34(): IACDCode {
        return this.FromId(18);
    }
    /**
		Returns A35 ACDCode
	**/
    get A35(): IACDCode {
        return this.FromId(19);
    }
    /**
		Returns A40 ACDCode
	**/
    get A40(): IACDCode {
        return this.FromId(20);
    }
    /**
		Returns A41 ACDCode
	**/
    get A41(): IACDCode {
        return this.FromId(21);
    }
    /**
		Returns A50 ACDCode
	**/
    get A50(): IACDCode {
        return this.FromId(22);
    }
    /**
		Returns A51 ACDCode
	**/
    get A51(): IACDCode {
        return this.FromId(23);
    }
    /**
		Returns A52 ACDCode
	**/
    get A52(): IACDCode {
        return this.FromId(24);
    }
    /**
		Returns A60 ACDCode
	**/
    get A60(): IACDCode {
        return this.FromId(25);
    }
    /**
		Returns A61 ACDCode
	**/
    get A61(): IACDCode {
        return this.FromId(26);
    }
    /**
		Returns A90 ACDCode
	**/
    get A90(): IACDCode {
        return this.FromId(27);
    }
    /**
		Returns A91 ACDCode
	**/
    get A91(): IACDCode {
        return this.FromId(28);
    }
    /**
		Returns A94 ACDCode
	**/
    get A94(): IACDCode {
        return this.FromId(29);
    }
    /**
		Returns A98 ACDCode
	**/
    get A98(): IACDCode {
        return this.FromId(30);
    }
    /**
		Returns B01 ACDCode
	**/
    get B01(): IACDCode {
        return this.FromId(31);
    }
    /**
		Returns B02 ACDCode
	**/
    get B02(): IACDCode {
        return this.FromId(32);
    }
    /**
		Returns B03 ACDCode
	**/
    get B03(): IACDCode {
        return this.FromId(33);
    }
    /**
		Returns B04 ACDCode
	**/
    get B04(): IACDCode {
        return this.FromId(34);
    }
    /**
		Returns B05 ACDCode
	**/
    get B05(): IACDCode {
        return this.FromId(35);
    }
    /**
		Returns B06 ACDCode
	**/
    get B06(): IACDCode {
        return this.FromId(36);
    }
    /**
		Returns B07 ACDCode
	**/
    get B07(): IACDCode {
        return this.FromId(37);
    }
    /**
		Returns B08 ACDCode
	**/
    get B08(): IACDCode {
        return this.FromId(38);
    }
    /**
		Returns B09 ACDCode
	**/
    get B09(): IACDCode {
        return this.FromId(39);
    }
    /**
		Returns B10 ACDCode
	**/
    get B10(): IACDCode {
        return this.FromId(40);
    }
    /**
		Returns B11 ACDCode
	**/
    get B11(): IACDCode {
        return this.FromId(41);
    }
    /**
		Returns B12 ACDCode
	**/
    get B12(): IACDCode {
        return this.FromId(42);
    }
    /**
		Returns B13 ACDCode
	**/
    get B13(): IACDCode {
        return this.FromId(43);
    }
    /**
		Returns B14 ACDCode
	**/
    get B14(): IACDCode {
        return this.FromId(44);
    }
    /**
		Returns B19 ACDCode
	**/
    get B19(): IACDCode {
        return this.FromId(45);
    }
    /**
		Returns B20 ACDCode
	**/
    get B20(): IACDCode {
        return this.FromId(46);
    }
    /**
		Returns B21 ACDCode
	**/
    get B21(): IACDCode {
        return this.FromId(47);
    }
    /**
		Returns B22 ACDCode
	**/
    get B22(): IACDCode {
        return this.FromId(48);
    }
    /**
		Returns B23 ACDCode
	**/
    get B23(): IACDCode {
        return this.FromId(49);
    }
    /**
		Returns B24 ACDCode
	**/
    get B24(): IACDCode {
        return this.FromId(50);
    }
    /**
		Returns B25 ACDCode
	**/
    get B25(): IACDCode {
        return this.FromId(51);
    }
    /**
		Returns B26 ACDCode
	**/
    get B26(): IACDCode {
        return this.FromId(52);
    }
    /**
		Returns B27 ACDCode
	**/
    get B27(): IACDCode {
        return this.FromId(53);
    }
    /**
		Returns B28 ACDCode
	**/
    get B28(): IACDCode {
        return this.FromId(54);
    }
    /**
		Returns B29 ACDCode
	**/
    get B29(): IACDCode {
        return this.FromId(55);
    }
    /**
		Returns B30 ACDCode
	**/
    get B30(): IACDCode {
        return this.FromId(56);
    }
    /**
		Returns B40 ACDCode
	**/
    get B40(): IACDCode {
        return this.FromId(57);
    }
    /**
		Returns B41 ACDCode
	**/
    get B41(): IACDCode {
        return this.FromId(58);
    }
    /**
		Returns B42 ACDCode
	**/
    get B42(): IACDCode {
        return this.FromId(59);
    }
    /**
		Returns B43 ACDCode
	**/
    get B43(): IACDCode {
        return this.FromId(60);
    }
    /**
		Returns B44 ACDCode
	**/
    get B44(): IACDCode {
        return this.FromId(61);
    }
    /**
		Returns B45 ACDCode
	**/
    get B45(): IACDCode {
        return this.FromId(62);
    }
    /**
		Returns B46 ACDCode
	**/
    get B46(): IACDCode {
        return this.FromId(63);
    }
    /**
		Returns B50 ACDCode
	**/
    get B50(): IACDCode {
        return this.FromId(64);
    }
    /**
		Returns B51 ACDCode
	**/
    get B51(): IACDCode {
        return this.FromId(65);
    }
    /**
		Returns B52 ACDCode
	**/
    get B52(): IACDCode {
        return this.FromId(66);
    }
    /**
		Returns B53 ACDCode
	**/
    get B53(): IACDCode {
        return this.FromId(67);
    }
    /**
		Returns B54 ACDCode
	**/
    get B54(): IACDCode {
        return this.FromId(68);
    }
    /**
		Returns B55 ACDCode
	**/
    get B55(): IACDCode {
        return this.FromId(69);
    }
    /**
		Returns B56 ACDCode
	**/
    get B56(): IACDCode {
        return this.FromId(70);
    }
    /**
		Returns B57 ACDCode
	**/
    get B57(): IACDCode {
        return this.FromId(71);
    }
    /**
		Returns B60 ACDCode
	**/
    get B60(): IACDCode {
        return this.FromId(72);
    }
    /**
		Returns B61 ACDCode
	**/
    get B61(): IACDCode {
        return this.FromId(73);
    }
    /**
		Returns B62 ACDCode
	**/
    get B62(): IACDCode {
        return this.FromId(74);
    }
    /**
		Returns B63 ACDCode
	**/
    get B63(): IACDCode {
        return this.FromId(75);
    }
    /**
		Returns B64 ACDCode
	**/
    get B64(): IACDCode {
        return this.FromId(76);
    }
    /**
		Returns B65 ACDCode
	**/
    get B65(): IACDCode {
        return this.FromId(77);
    }
    /**
		Returns B70 ACDCode
	**/
    get B70(): IACDCode {
        return this.FromId(78);
    }
    /**
		Returns B71 ACDCode
	**/
    get B71(): IACDCode {
        return this.FromId(79);
    }
    /**
		Returns B72 ACDCode
	**/
    get B72(): IACDCode {
        return this.FromId(80);
    }
    /**
		Returns B73 ACDCode
	**/
    get B73(): IACDCode {
        return this.FromId(81);
    }
    /**
		Returns B74 ACDCode
	**/
    get B74(): IACDCode {
        return this.FromId(82);
    }
    /**
		Returns B75 ACDCode
	**/
    get B75(): IACDCode {
        return this.FromId(83);
    }
    /**
		Returns B76 ACDCode
	**/
    get B76(): IACDCode {
        return this.FromId(84);
    }
    /**
		Returns B77 ACDCode
	**/
    get B77(): IACDCode {
        return this.FromId(85);
    }
    /**
		Returns B78 ACDCode
	**/
    get B78(): IACDCode {
        return this.FromId(86);
    }
    /**
		Returns B80 ACDCode
	**/
    get B80(): IACDCode {
        return this.FromId(87);
    }
    /**
		Returns B81 ACDCode
	**/
    get B81(): IACDCode {
        return this.FromId(88);
    }
    /**
		Returns B82 ACDCode
	**/
    get B82(): IACDCode {
        return this.FromId(89);
    }
    /**
		Returns B83 ACDCode
	**/
    get B83(): IACDCode {
        return this.FromId(90);
    }
    /**
		Returns B84 ACDCode
	**/
    get B84(): IACDCode {
        return this.FromId(91);
    }
    /**
		Returns B85 ACDCode
	**/
    get B85(): IACDCode {
        return this.FromId(92);
    }
    /**
		Returns B86 ACDCode
	**/
    get B86(): IACDCode {
        return this.FromId(93);
    }
    /**
		Returns B87 ACDCode
	**/
    get B87(): IACDCode {
        return this.FromId(94);
    }
    /**
		Returns B88 ACDCode
	**/
    get B88(): IACDCode {
        return this.FromId(95);
    }
    /**
		Returns B89 ACDCode
	**/
    get B89(): IACDCode {
        return this.FromId(96);
    }
    /**
		Returns B90 ACDCode
	**/
    get B90(): IACDCode {
        return this.FromId(97);
    }
    /**
		Returns B91 ACDCode
	**/
    get B91(): IACDCode {
        return this.FromId(98);
    }
    /**
		Returns B92 ACDCode
	**/
    get B92(): IACDCode {
        return this.FromId(99);
    }
    /**
		Returns B93 ACDCode
	**/
    get B93(): IACDCode {
        return this.FromId(100);
    }
    /**
		Returns D01 ACDCode
	**/
    get D01(): IACDCode {
        return this.FromId(101);
    }
    /**
		Returns D02 ACDCode
	**/
    get D02(): IACDCode {
        return this.FromId(102);
    }
    /**
		Returns D03 ACDCode
	**/
    get D03(): IACDCode {
        return this.FromId(103);
    }
    /**
		Returns D04 ACDCode
	**/
    get D04(): IACDCode {
        return this.FromId(104);
    }
    /**
		Returns D05 ACDCode
	**/
    get D05(): IACDCode {
        return this.FromId(105);
    }
    /**
		Returns D06 ACDCode
	**/
    get D06(): IACDCode {
        return this.FromId(106);
    }
    /**
		Returns D07 ACDCode
	**/
    get D07(): IACDCode {
        return this.FromId(107);
    }
    /**
		Returns D10 ACDCode
	**/
    get D10(): IACDCode {
        return this.FromId(108);
    }
    /**
		Returns D11 ACDCode
	**/
    get D11(): IACDCode {
        return this.FromId(109);
    }
    /**
		Returns D12 ACDCode
	**/
    get D12(): IACDCode {
        return this.FromId(110);
    }
    /**
		Returns D15 ACDCode
	**/
    get D15(): IACDCode {
        return this.FromId(111);
    }
    /**
		Returns D16 ACDCode
	**/
    get D16(): IACDCode {
        return this.FromId(112);
    }
    /**
		Returns D17 ACDCode
	**/
    get D17(): IACDCode {
        return this.FromId(113);
    }
    /**
		Returns D18 ACDCode
	**/
    get D18(): IACDCode {
        return this.FromId(114);
    }
    /**
		Returns D19 ACDCode
	**/
    get D19(): IACDCode {
        return this.FromId(115);
    }
    /**
		Returns D20 ACDCode
	**/
    get D20(): IACDCode {
        return this.FromId(116);
    }
    /**
		Returns D21 ACDCode
	**/
    get D21(): IACDCode {
        return this.FromId(117);
    }
    /**
		Returns D25 ACDCode
	**/
    get D25(): IACDCode {
        return this.FromId(118);
    }
    /**
		Returns D26 ACDCode
	**/
    get D26(): IACDCode {
        return this.FromId(119);
    }
    /**
		Returns D27 ACDCode
	**/
    get D27(): IACDCode {
        return this.FromId(120);
    }
    /**
		Returns D28 ACDCode
	**/
    get D28(): IACDCode {
        return this.FromId(121);
    }
    /**
		Returns D29 ACDCode
	**/
    get D29(): IACDCode {
        return this.FromId(122);
    }
    /**
		Returns D30 ACDCode
	**/
    get D30(): IACDCode {
        return this.FromId(123);
    }
    /**
		Returns D31 ACDCode
	**/
    get D31(): IACDCode {
        return this.FromId(124);
    }
    /**
		Returns D35 ACDCode
	**/
    get D35(): IACDCode {
        return this.FromId(125);
    }
    /**
		Returns D36 ACDCode
	**/
    get D36(): IACDCode {
        return this.FromId(126);
    }
    /**
		Returns D37 ACDCode
	**/
    get D37(): IACDCode {
        return this.FromId(127);
    }
    /**
		Returns D38 ACDCode
	**/
    get D38(): IACDCode {
        return this.FromId(128);
    }
    /**
		Returns D39 ACDCode
	**/
    get D39(): IACDCode {
        return this.FromId(129);
    }
    /**
		Returns D40 ACDCode
	**/
    get D40(): IACDCode {
        return this.FromId(130);
    }
    /**
		Returns D41 ACDCode
	**/
    get D41(): IACDCode {
        return this.FromId(131);
    }
    /**
		Returns D42 ACDCode
	**/
    get D42(): IACDCode {
        return this.FromId(132);
    }
    /**
		Returns D43 ACDCode
	**/
    get D43(): IACDCode {
        return this.FromId(133);
    }
    /**
		Returns D44 ACDCode
	**/
    get D44(): IACDCode {
        return this.FromId(134);
    }
    /**
		Returns D45 ACDCode
	**/
    get D45(): IACDCode {
        return this.FromId(135);
    }
    /**
		Returns D50 ACDCode
	**/
    get D50(): IACDCode {
        return this.FromId(136);
    }
    /**
		Returns D51 ACDCode
	**/
    get D51(): IACDCode {
        return this.FromId(137);
    }
    /**
		Returns D52 ACDCode
	**/
    get D52(): IACDCode {
        return this.FromId(138);
    }
    /**
		Returns D53 ACDCode
	**/
    get D53(): IACDCode {
        return this.FromId(139);
    }
    /**
		Returns D54 ACDCode
	**/
    get D54(): IACDCode {
        return this.FromId(140);
    }
    /**
		Returns D55 ACDCode
	**/
    get D55(): IACDCode {
        return this.FromId(141);
    }
    /**
		Returns D56 ACDCode
	**/
    get D56(): IACDCode {
        return this.FromId(142);
    }
    /**
		Returns D65 ACDCode
	**/
    get D65(): IACDCode {
        return this.FromId(143);
    }
    /**
		Returns D66 ACDCode
	**/
    get D66(): IACDCode {
        return this.FromId(144);
    }
    /**
		Returns D67 ACDCode
	**/
    get D67(): IACDCode {
        return this.FromId(145);
    }
    /**
		Returns D68 ACDCode
	**/
    get D68(): IACDCode {
        return this.FromId(146);
    }
    /**
		Returns D70 ACDCode
	**/
    get D70(): IACDCode {
        return this.FromId(147);
    }
    /**
		Returns D71 ACDCode
	**/
    get D71(): IACDCode {
        return this.FromId(148);
    }
    /**
		Returns D72 ACDCode
	**/
    get D72(): IACDCode {
        return this.FromId(149);
    }
    /**
		Returns D73 ACDCode
	**/
    get D73(): IACDCode {
        return this.FromId(150);
    }
    /**
		Returns D74 ACDCode
	**/
    get D74(): IACDCode {
        return this.FromId(151);
    }
    /**
		Returns D75 ACDCode
	**/
    get D75(): IACDCode {
        return this.FromId(152);
    }
    /**
		Returns D76 ACDCode
	**/
    get D76(): IACDCode {
        return this.FromId(153);
    }
    /**
		Returns D77 ACDCode
	**/
    get D77(): IACDCode {
        return this.FromId(154);
    }
    /**
		Returns D78 ACDCode
	**/
    get D78(): IACDCode {
        return this.FromId(155);
    }
    /**
		Returns E01 ACDCode
	**/
    get E01(): IACDCode {
        return this.FromId(156);
    }
    /**
		Returns E02 ACDCode
	**/
    get E02(): IACDCode {
        return this.FromId(157);
    }
    /**
		Returns E03 ACDCode
	**/
    get E03(): IACDCode {
        return this.FromId(158);
    }
    /**
		Returns E04 ACDCode
	**/
    get E04(): IACDCode {
        return this.FromId(159);
    }
    /**
		Returns E05 ACDCode
	**/
    get E05(): IACDCode {
        return this.FromId(160);
    }
    /**
		Returns E06 ACDCode
	**/
    get E06(): IACDCode {
        return this.FromId(161);
    }
    /**
		Returns E20 ACDCode
	**/
    get E20(): IACDCode {
        return this.FromId(162);
    }
    /**
		Returns E21 ACDCode
	**/
    get E21(): IACDCode {
        return this.FromId(163);
    }
    /**
		Returns E22 ACDCode
	**/
    get E22(): IACDCode {
        return this.FromId(164);
    }
    /**
		Returns E23 ACDCode
	**/
    get E23(): IACDCode {
        return this.FromId(165);
    }
    /**
		Returns E24 ACDCode
	**/
    get E24(): IACDCode {
        return this.FromId(166);
    }
    /**
		Returns E30 ACDCode
	**/
    get E30(): IACDCode {
        return this.FromId(167);
    }
    /**
		Returns E31 ACDCode
	**/
    get E31(): IACDCode {
        return this.FromId(168);
    }
    /**
		Returns E32 ACDCode
	**/
    get E32(): IACDCode {
        return this.FromId(169);
    }
    /**
		Returns E33 ACDCode
	**/
    get E33(): IACDCode {
        return this.FromId(170);
    }
    /**
		Returns E34 ACDCode
	**/
    get E34(): IACDCode {
        return this.FromId(171);
    }
    /**
		Returns E35 ACDCode
	**/
    get E35(): IACDCode {
        return this.FromId(172);
    }
    /**
		Returns E36 ACDCode
	**/
    get E36(): IACDCode {
        return this.FromId(173);
    }
    /**
		Returns E37 ACDCode
	**/
    get E37(): IACDCode {
        return this.FromId(174);
    }
    /**
		Returns E50 ACDCode
	**/
    get E50(): IACDCode {
        return this.FromId(175);
    }
    /**
		Returns E51 ACDCode
	**/
    get E51(): IACDCode {
        return this.FromId(176);
    }
    /**
		Returns E52 ACDCode
	**/
    get E52(): IACDCode {
        return this.FromId(177);
    }
    /**
		Returns E53 ACDCode
	**/
    get E53(): IACDCode {
        return this.FromId(178);
    }
    /**
		Returns E54 ACDCode
	**/
    get E54(): IACDCode {
        return this.FromId(179);
    }
    /**
		Returns E55 ACDCode
	**/
    get E55(): IACDCode {
        return this.FromId(180);
    }
    /**
		Returns E56 ACDCode
	**/
    get E56(): IACDCode {
        return this.FromId(181);
    }
    /**
		Returns E57 ACDCode
	**/
    get E57(): IACDCode {
        return this.FromId(182);
    }
    /**
		Returns E70 ACDCode
	**/
    get E70(): IACDCode {
        return this.FromId(183);
    }
    /**
		Returns E71 ACDCode
	**/
    get E71(): IACDCode {
        return this.FromId(184);
    }
    /**
		Returns E72 ACDCode
	**/
    get E72(): IACDCode {
        return this.FromId(185);
    }
    /**
		Returns E73 ACDCode
	**/
    get E73(): IACDCode {
        return this.FromId(186);
    }
    /**
		Returns E74 ACDCode
	**/
    get E74(): IACDCode {
        return this.FromId(187);
    }
    /**
		Returns E80 ACDCode
	**/
    get E80(): IACDCode {
        return this.FromId(188);
    }
    /**
		Returns F01 ACDCode
	**/
    get F01(): IACDCode {
        return this.FromId(189);
    }
    /**
		Returns F02 ACDCode
	**/
    get F02(): IACDCode {
        return this.FromId(190);
    }
    /**
		Returns F03 ACDCode
	**/
    get F03(): IACDCode {
        return this.FromId(191);
    }
    /**
		Returns F04 ACDCode
	**/
    get F04(): IACDCode {
        return this.FromId(192);
    }
    /**
		Returns F05 ACDCode
	**/
    get F05(): IACDCode {
        return this.FromId(193);
    }
    /**
		Returns F06 ACDCode
	**/
    get F06(): IACDCode {
        return this.FromId(194);
    }
    /**
		Returns F10 ACDCode
	**/
    get F10(): IACDCode {
        return this.FromId(195);
    }
    /**
		Returns F11 ACDCode
	**/
    get F11(): IACDCode {
        return this.FromId(196);
    }
    /**
		Returns F12 ACDCode
	**/
    get F12(): IACDCode {
        return this.FromId(197);
    }
    /**
		Returns F13 ACDCode
	**/
    get F13(): IACDCode {
        return this.FromId(198);
    }
    /**
		Returns F14 ACDCode
	**/
    get F14(): IACDCode {
        return this.FromId(199);
    }
    /**
		Returns F15 ACDCode
	**/
    get F15(): IACDCode {
        return this.FromId(200);
    }
    /**
		Returns F16 ACDCode
	**/
    get F16(): IACDCode {
        return this.FromId(201);
    }
    /**
		Returns F20 ACDCode
	**/
    get F20(): IACDCode {
        return this.FromId(202);
    }
    /**
		Returns F21 ACDCode
	**/
    get F21(): IACDCode {
        return this.FromId(203);
    }
    /**
		Returns F22 ACDCode
	**/
    get F22(): IACDCode {
        return this.FromId(204);
    }
    /**
		Returns F23 ACDCode
	**/
    get F23(): IACDCode {
        return this.FromId(205);
    }
    /**
		Returns F24 ACDCode
	**/
    get F24(): IACDCode {
        return this.FromId(206);
    }
    /**
		Returns F30 ACDCode
	**/
    get F30(): IACDCode {
        return this.FromId(207);
    }
    /**
		Returns F31 ACDCode
	**/
    get F31(): IACDCode {
        return this.FromId(208);
    }
    /**
		Returns F32 ACDCode
	**/
    get F32(): IACDCode {
        return this.FromId(209);
    }
    /**
		Returns F33 ACDCode
	**/
    get F33(): IACDCode {
        return this.FromId(210);
    }
    /**
		Returns F34 ACDCode
	**/
    get F34(): IACDCode {
        return this.FromId(211);
    }
    /**
		Returns F35 ACDCode
	**/
    get F35(): IACDCode {
        return this.FromId(212);
    }
    /**
		Returns F40 ACDCode
	**/
    get F40(): IACDCode {
        return this.FromId(213);
    }
    /**
		Returns F41 ACDCode
	**/
    get F41(): IACDCode {
        return this.FromId(214);
    }
    /**
		Returns F60 ACDCode
	**/
    get F60(): IACDCode {
        return this.FromId(215);
    }
    /**
		Returns F61 ACDCode
	**/
    get F61(): IACDCode {
        return this.FromId(216);
    }
    /**
		Returns F62 ACDCode
	**/
    get F62(): IACDCode {
        return this.FromId(217);
    }
    /**
		Returns F63 ACDCode
	**/
    get F63(): IACDCode {
        return this.FromId(218);
    }
    /**
		Returns F64 ACDCode
	**/
    get F64(): IACDCode {
        return this.FromId(219);
    }
    /**
		Returns F65 ACDCode
	**/
    get F65(): IACDCode {
        return this.FromId(220);
    }
    /**
		Returns F66 ACDCode
	**/
    get F66(): IACDCode {
        return this.FromId(221);
    }
    /**
		Returns M01 ACDCode
	**/
    get M01(): IACDCode {
        return this.FromId(222);
    }
    /**
		Returns M02 ACDCode
	**/
    get M02(): IACDCode {
        return this.FromId(223);
    }
    /**
		Returns M03 ACDCode
	**/
    get M03(): IACDCode {
        return this.FromId(224);
    }
    /**
		Returns M04 ACDCode
	**/
    get M04(): IACDCode {
        return this.FromId(225);
    }
    /**
		Returns M05 ACDCode
	**/
    get M05(): IACDCode {
        return this.FromId(226);
    }
    /**
		Returns M06 ACDCode
	**/
    get M06(): IACDCode {
        return this.FromId(227);
    }
    /**
		Returns M07 ACDCode
	**/
    get M07(): IACDCode {
        return this.FromId(228);
    }
    /**
		Returns M08 ACDCode
	**/
    get M08(): IACDCode {
        return this.FromId(229);
    }
    /**
		Returns M09 ACDCode
	**/
    get M09(): IACDCode {
        return this.FromId(230);
    }
    /**
		Returns M10 ACDCode
	**/
    get M10(): IACDCode {
        return this.FromId(231);
    }
    /**
		Returns M11 ACDCode
	**/
    get M11(): IACDCode {
        return this.FromId(232);
    }
    /**
		Returns M12 ACDCode
	**/
    get M12(): IACDCode {
        return this.FromId(233);
    }
    /**
		Returns M13 ACDCode
	**/
    get M13(): IACDCode {
        return this.FromId(234);
    }
    /**
		Returns M14 ACDCode
	**/
    get M14(): IACDCode {
        return this.FromId(235);
    }
    /**
		Returns M15 ACDCode
	**/
    get M15(): IACDCode {
        return this.FromId(236);
    }
    /**
		Returns M16 ACDCode
	**/
    get M16(): IACDCode {
        return this.FromId(237);
    }
    /**
		Returns M17 ACDCode
	**/
    get M17(): IACDCode {
        return this.FromId(238);
    }
    /**
		Returns M18 ACDCode
	**/
    get M18(): IACDCode {
        return this.FromId(239);
    }
    /**
		Returns M19 ACDCode
	**/
    get M19(): IACDCode {
        return this.FromId(240);
    }
    /**
		Returns M20 ACDCode
	**/
    get M20(): IACDCode {
        return this.FromId(241);
    }
    /**
		Returns M21 ACDCode
	**/
    get M21(): IACDCode {
        return this.FromId(242);
    }
    /**
		Returns M22 ACDCode
	**/
    get M22(): IACDCode {
        return this.FromId(243);
    }
    /**
		Returns M23 ACDCode
	**/
    get M23(): IACDCode {
        return this.FromId(244);
    }
    /**
		Returns M24 ACDCode
	**/
    get M24(): IACDCode {
        return this.FromId(245);
    }
    /**
		Returns M25 ACDCode
	**/
    get M25(): IACDCode {
        return this.FromId(246);
    }
    /**
		Returns M30 ACDCode
	**/
    get M30(): IACDCode {
        return this.FromId(247);
    }
    /**
		Returns M31 ACDCode
	**/
    get M31(): IACDCode {
        return this.FromId(248);
    }
    /**
		Returns M32 ACDCode
	**/
    get M32(): IACDCode {
        return this.FromId(249);
    }
    /**
		Returns M33 ACDCode
	**/
    get M33(): IACDCode {
        return this.FromId(250);
    }
    /**
		Returns M34 ACDCode
	**/
    get M34(): IACDCode {
        return this.FromId(251);
    }
    /**
		Returns M40 ACDCode
	**/
    get M40(): IACDCode {
        return this.FromId(252);
    }
    /**
		Returns M41 ACDCode
	**/
    get M41(): IACDCode {
        return this.FromId(253);
    }
    /**
		Returns M42 ACDCode
	**/
    get M42(): IACDCode {
        return this.FromId(254);
    }
    /**
		Returns M43 ACDCode
	**/
    get M43(): IACDCode {
        return this.FromId(255);
    }
    /**
		Returns M44 ACDCode
	**/
    get M44(): IACDCode {
        return this.FromId(256);
    }
    /**
		Returns M45 ACDCode
	**/
    get M45(): IACDCode {
        return this.FromId(257);
    }
    /**
		Returns M46 ACDCode
	**/
    get M46(): IACDCode {
        return this.FromId(258);
    }
    /**
		Returns M47 ACDCode
	**/
    get M47(): IACDCode {
        return this.FromId(259);
    }
    /**
		Returns M48 ACDCode
	**/
    get M48(): IACDCode {
        return this.FromId(260);
    }
    /**
		Returns M49 ACDCode
	**/
    get M49(): IACDCode {
        return this.FromId(261);
    }
    /**
		Returns M50 ACDCode
	**/
    get M50(): IACDCode {
        return this.FromId(262);
    }
    /**
		Returns M51 ACDCode
	**/
    get M51(): IACDCode {
        return this.FromId(263);
    }
    /**
		Returns M52 ACDCode
	**/
    get M52(): IACDCode {
        return this.FromId(264);
    }
    /**
		Returns M53 ACDCode
	**/
    get M53(): IACDCode {
        return this.FromId(265);
    }
    /**
		Returns M54 ACDCode
	**/
    get M54(): IACDCode {
        return this.FromId(266);
    }
    /**
		Returns M55 ACDCode
	**/
    get M55(): IACDCode {
        return this.FromId(267);
    }
    /**
		Returns M56 ACDCode
	**/
    get M56(): IACDCode {
        return this.FromId(268);
    }
    /**
		Returns M57 ACDCode
	**/
    get M57(): IACDCode {
        return this.FromId(269);
    }
    /**
		Returns M58 ACDCode
	**/
    get M58(): IACDCode {
        return this.FromId(270);
    }
    /**
		Returns M60 ACDCode
	**/
    get M60(): IACDCode {
        return this.FromId(271);
    }
    /**
		Returns M61 ACDCode
	**/
    get M61(): IACDCode {
        return this.FromId(272);
    }
    /**
		Returns M62 ACDCode
	**/
    get M62(): IACDCode {
        return this.FromId(273);
    }
    /**
		Returns M70 ACDCode
	**/
    get M70(): IACDCode {
        return this.FromId(274);
    }
    /**
		Returns M71 ACDCode
	**/
    get M71(): IACDCode {
        return this.FromId(275);
    }
    /**
		Returns M72 ACDCode
	**/
    get M72(): IACDCode {
        return this.FromId(276);
    }
    /**
		Returns M73 ACDCode
	**/
    get M73(): IACDCode {
        return this.FromId(277);
    }
    /**
		Returns M74 ACDCode
	**/
    get M74(): IACDCode {
        return this.FromId(278);
    }
    /**
		Returns M75 ACDCode
	**/
    get M75(): IACDCode {
        return this.FromId(279);
    }
    /**
		Returns M76 ACDCode
	**/
    get M76(): IACDCode {
        return this.FromId(280);
    }
    /**
		Returns M77 ACDCode
	**/
    get M77(): IACDCode {
        return this.FromId(281);
    }
    /**
		Returns M80 ACDCode
	**/
    get M80(): IACDCode {
        return this.FromId(282);
    }
    /**
		Returns M81 ACDCode
	**/
    get M81(): IACDCode {
        return this.FromId(283);
    }
    /**
		Returns M82 ACDCode
	**/
    get M82(): IACDCode {
        return this.FromId(284);
    }
    /**
		Returns M83 ACDCode
	**/
    get M83(): IACDCode {
        return this.FromId(285);
    }
    /**
		Returns M84 ACDCode
	**/
    get M84(): IACDCode {
        return this.FromId(286);
    }
    /**
		Returns M85 ACDCode
	**/
    get M85(): IACDCode {
        return this.FromId(287);
    }
    /**
		Returns M86 ACDCode
	**/
    get M86(): IACDCode {
        return this.FromId(288);
    }
    /**
		Returns N01 ACDCode
	**/
    get N01(): IACDCode {
        return this.FromId(289);
    }
    /**
		Returns N02 ACDCode
	**/
    get N02(): IACDCode {
        return this.FromId(290);
    }
    /**
		Returns N03 ACDCode
	**/
    get N03(): IACDCode {
        return this.FromId(291);
    }
    /**
		Returns N04 ACDCode
	**/
    get N04(): IACDCode {
        return this.FromId(292);
    }
    /**
		Returns N05 ACDCode
	**/
    get N05(): IACDCode {
        return this.FromId(293);
    }
    /**
		Returns N06 ACDCode
	**/
    get N06(): IACDCode {
        return this.FromId(294);
    }
    /**
		Returns N07 ACDCode
	**/
    get N07(): IACDCode {
        return this.FromId(295);
    }
    /**
		Returns N08 ACDCode
	**/
    get N08(): IACDCode {
        return this.FromId(296);
    }
    /**
		Returns N09 ACDCode
	**/
    get N09(): IACDCode {
        return this.FromId(297);
    }
    /**
		Returns N20 ACDCode
	**/
    get N20(): IACDCode {
        return this.FromId(298);
    }
    /**
		Returns N21 ACDCode
	**/
    get N21(): IACDCode {
        return this.FromId(299);
    }
    /**
		Returns N22 ACDCode
	**/
    get N22(): IACDCode {
        return this.FromId(300);
    }
    /**
		Returns N23 ACDCode
	**/
    get N23(): IACDCode {
        return this.FromId(301);
    }
    /**
		Returns N24 ACDCode
	**/
    get N24(): IACDCode {
        return this.FromId(302);
    }
    /**
		Returns N25 ACDCode
	**/
    get N25(): IACDCode {
        return this.FromId(303);
    }
    /**
		Returns N26 ACDCode
	**/
    get N26(): IACDCode {
        return this.FromId(304);
    }
    /**
		Returns N30 ACDCode
	**/
    get N30(): IACDCode {
        return this.FromId(305);
    }
    /**
		Returns N31 ACDCode
	**/
    get N31(): IACDCode {
        return this.FromId(306);
    }
    /**
		Returns N40 ACDCode
	**/
    get N40(): IACDCode {
        return this.FromId(307);
    }
    /**
		Returns N41 ACDCode
	**/
    get N41(): IACDCode {
        return this.FromId(308);
    }
    /**
		Returns N42 ACDCode
	**/
    get N42(): IACDCode {
        return this.FromId(309);
    }
    /**
		Returns N43 ACDCode
	**/
    get N43(): IACDCode {
        return this.FromId(310);
    }
    /**
		Returns N44 ACDCode
	**/
    get N44(): IACDCode {
        return this.FromId(311);
    }
    /**
		Returns N50 ACDCode
	**/
    get N50(): IACDCode {
        return this.FromId(312);
    }
    /**
		Returns N51 ACDCode
	**/
    get N51(): IACDCode {
        return this.FromId(313);
    }
    /**
		Returns N52 ACDCode
	**/
    get N52(): IACDCode {
        return this.FromId(314);
    }
    /**
		Returns N53 ACDCode
	**/
    get N53(): IACDCode {
        return this.FromId(315);
    }
    /**
		Returns N54 ACDCode
	**/
    get N54(): IACDCode {
        return this.FromId(316);
    }
    /**
		Returns N55 ACDCode
	**/
    get N55(): IACDCode {
        return this.FromId(317);
    }
    /**
		Returns N56 ACDCode
	**/
    get N56(): IACDCode {
        return this.FromId(318);
    }
    /**
		Returns N60 ACDCode
	**/
    get N60(): IACDCode {
        return this.FromId(319);
    }
    /**
		Returns N61 ACDCode
	**/
    get N61(): IACDCode {
        return this.FromId(320);
    }
    /**
		Returns N62 ACDCode
	**/
    get N62(): IACDCode {
        return this.FromId(321);
    }
    /**
		Returns N63 ACDCode
	**/
    get N63(): IACDCode {
        return this.FromId(322);
    }
    /**
		Returns N70 ACDCode
	**/
    get N70(): IACDCode {
        return this.FromId(323);
    }
    /**
		Returns N71 ACDCode
	**/
    get N71(): IACDCode {
        return this.FromId(324);
    }
    /**
		Returns N72 ACDCode
	**/
    get N72(): IACDCode {
        return this.FromId(325);
    }
    /**
		Returns N80 ACDCode
	**/
    get N80(): IACDCode {
        return this.FromId(326);
    }
    /**
		Returns N81 ACDCode
	**/
    get N81(): IACDCode {
        return this.FromId(327);
    }
    /**
		Returns N82 ACDCode
	**/
    get N82(): IACDCode {
        return this.FromId(328);
    }
    /**
		Returns N83 ACDCode
	**/
    get N83(): IACDCode {
        return this.FromId(329);
    }
    /**
		Returns N84 ACDCode
	**/
    get N84(): IACDCode {
        return this.FromId(330);
    }
    /**
		Returns R18 ACDCode
	**/
    get R17(): IACDCode {
        return this.FromId(331);
    }
    /**
		Returns S01 ACDCode
	**/
    get S01(): IACDCode {
        return this.FromId(332);
    }
    /**
		Returns S06 ACDCode
	**/
    get S06(): IACDCode {
        return this.FromId(333);
    }
    /**
		Returns S11 ACDCode
	**/
    get S11(): IACDCode {
        return this.FromId(334);
    }
    /**
		Returns S14 ACDCode
	**/
    get S14(): IACDCode {
        return this.FromId(335);
    }
    /**
		Returns S15 ACDCode
	**/
    get S15(): IACDCode {
        return this.FromId(336);
    }
    /**
		Returns S16 ACDCode
	**/
    get S16(): IACDCode {
        return this.FromId(337);
    }
    /**
		Returns S21 ACDCode
	**/
    get S21(): IACDCode {
        return this.FromId(338);
    }
    /**
		Returns S26 ACDCode
	**/
    get S26(): IACDCode {
        return this.FromId(339);
    }
    /**
		Returns S31 ACDCode
	**/
    get S31(): IACDCode {
        return this.FromId(340);
    }
    /**
		Returns S36 ACDCode
	**/
    get S36(): IACDCode {
        return this.FromId(341);
    }
    /**
		Returns S41 ACDCode
	**/
    get S41(): IACDCode {
        return this.FromId(342);
    }
    /**
		Returns S50 ACDCode
	**/
    get S50(): IACDCode {
        return this.FromId(343);
    }
    /**
		Returns S51 ACDCode
	**/
    get S51(): IACDCode {
        return this.FromId(344);
    }
    /**
		Returns S61 ACDCode
	**/
    get S61(): IACDCode {
        return this.FromId(345);
    }
    /**
		Returns S71 ACDCode
	**/
    get S71(): IACDCode {
        return this.FromId(346);
    }
    /**
		Returns S81 ACDCode
	**/
    get S81(): IACDCode {
        return this.FromId(347);
    }
    /**
		Returns S91 ACDCode
	**/
    get S91(): IACDCode {
        return this.FromId(348);
    }
    /**
		Returns S92 ACDCode
	**/
    get S92(): IACDCode {
        return this.FromId(349);
    }
    /**
		Returns S93 ACDCode
	**/
    get S93(): IACDCode {
        return this.FromId(350);
    }
    /**
		Returns S94 ACDCode
	**/
    get S94(): IACDCode {
        return this.FromId(351);
    }
    /**
		Returns S95 ACDCode
	**/
    get S95(): IACDCode {
        return this.FromId(352);
    }
    /**
		Returns S96 ACDCode
	**/
    get S96(): IACDCode {
        return this.FromId(353);
    }
    /**
		Returns S97 ACDCode
	**/
    get S97(): IACDCode {
        return this.FromId(354);
    }
    /**
		Returns S98 ACDCode
	**/
    get S98(): IACDCode {
        return this.FromId(355);
    }
    /**
		Returns S99 ACDCode
	**/
    get S99(): IACDCode {
        return this.FromId(356);
    }
    /**
		Returns U01 ACDCode
	**/
    get U01(): IACDCode {
        return this.FromId(357);
    }
    /**
		Returns U02 ACDCode
	**/
    get U02(): IACDCode {
        return this.FromId(358);
    }
    /**
		Returns U03 ACDCode
	**/
    get U03(): IACDCode {
        return this.FromId(359);
    }
    /**
		Returns U04 ACDCode
	**/
    get U04(): IACDCode {
        return this.FromId(360);
    }
    /**
		Returns U05 ACDCode
	**/
    get U05(): IACDCode {
        return this.FromId(361);
    }
    /**
		Returns U06 ACDCode
	**/
    get U06(): IACDCode {
        return this.FromId(362);
    }
    /**
		Returns U07 ACDCode
	**/
    get U07(): IACDCode {
        return this.FromId(363);
    }
    /**
		Returns U08 ACDCode
	**/
    get U08(): IACDCode {
        return this.FromId(364);
    }
    /**
		Returns U09 ACDCode
	**/
    get U09(): IACDCode {
        return this.FromId(365);
    }
    /**
		Returns U10 ACDCode
	**/
    get U10(): IACDCode {
        return this.FromId(366);
    }
    /**
		Returns U20 ACDCode
	**/
    get U20(): IACDCode {
        return this.FromId(367);
    }
    /**
		Returns U21 ACDCode
	**/
    get U21(): IACDCode {
        return this.FromId(368);
    }
    /**
		Returns U22 ACDCode
	**/
    get U22(): IACDCode {
        return this.FromId(369);
    }
    /**
		Returns U23 ACDCode
	**/
    get U23(): IACDCode {
        return this.FromId(370);
    }
    /**
		Returns U24 ACDCode
	**/
    get U24(): IACDCode {
        return this.FromId(371);
    }
    /**
		Returns U25 ACDCode
	**/
    get U25(): IACDCode {
        return this.FromId(372);
    }
    /**
		Returns U26 ACDCode
	**/
    get U26(): IACDCode {
        return this.FromId(373);
    }
    /**
		Returns U27 ACDCode
	**/
    get U27(): IACDCode {
        return this.FromId(374);
    }
    /**
		Returns U28 ACDCode
	**/
    get U28(): IACDCode {
        return this.FromId(375);
    }
    /**
		Returns U30 ACDCode
	**/
    get U30(): IACDCode {
        return this.FromId(376);
    }
    /**
		Returns U31 ACDCode
	**/
    get U31(): IACDCode {
        return this.FromId(377);
    }
    /**
		Returns U32 ACDCode
	**/
    get U32(): IACDCode {
        return this.FromId(378);
    }
    /**
		Returns U33 ACDCode
	**/
    get U33(): IACDCode {
        return this.FromId(379);
    }
    /**
		Returns W00 ACDCode
	**/
    get W00(): IACDCode {
        return this.FromId(380);
    }
    /**
		Returns W01 ACDCode
	**/
    get W01(): IACDCode {
        return this.FromId(381);
    }
    /**
		Returns W09 ACDCode
	**/
    get W09(): IACDCode {
        return this.FromId(382);
    }
    /**
		Returns W10 ACDCode
	**/
    get W10(): IACDCode {
        return this.FromId(383);
    }
    /**
		Returns W11 ACDCode
	**/
    get W11(): IACDCode {
        return this.FromId(384);
    }
    /**
		Returns W12 ACDCode
	**/
    get W12(): IACDCode {
        return this.FromId(385);
    }
    /**
		Returns W13 ACDCode
	**/
    get W13(): IACDCode {
        return this.FromId(386);
    }
    /**
		Returns W14 ACDCode
	**/
    get W14(): IACDCode {
        return this.FromId(387);
    }
    /**
		Returns W15 ACDCode
	**/
    get W15(): IACDCode {
        return this.FromId(388);
    }
    /**
		Returns W20 ACDCode
	**/
    get W20(): IACDCode {
        return this.FromId(389);
    }
    /**
		Returns W21 ACDCode
	**/
    get W21(): IACDCode {
        return this.FromId(390);
    }
    /**
		Returns W22 ACDCode
	**/
    get W22(): IACDCode {
        return this.FromId(391);
    }
    /**
		Returns W23 ACDCode
	**/
    get W23(): IACDCode {
        return this.FromId(392);
    }
    /**
		Returns W24 ACDCode
	**/
    get W24(): IACDCode {
        return this.FromId(393);
    }
    /**
		Returns W25 ACDCode
	**/
    get W25(): IACDCode {
        return this.FromId(394);
    }
    /**
		Returns W26 ACDCode
	**/
    get W26(): IACDCode {
        return this.FromId(395);
    }
    /**
		Returns W27 ACDCode
	**/
    get W27(): IACDCode {
        return this.FromId(396);
    }
    /**
		Returns W28 ACDCode
	**/
    get W28(): IACDCode {
        return this.FromId(397);
    }
    /**
		Returns W30 ACDCode
	**/
    get W30(): IACDCode {
        return this.FromId(398);
    }
    /**
		Returns W31 ACDCode
	**/
    get W31(): IACDCode {
        return this.FromId(399);
    }
    /**
		Returns W40 ACDCode
	**/
    get W40(): IACDCode {
        return this.FromId(400);
    }
    /**
		Returns W41 ACDCode
	**/
    get W41(): IACDCode {
        return this.FromId(401);
    }
    /**
		Returns W45 ACDCode
	**/
    get W45(): IACDCode {
        return this.FromId(402);
    }
    /**
		Returns W50 ACDCode
	**/
    get W50(): IACDCode {
        return this.FromId(403);
    }
    /**
		Returns W51 ACDCode
	**/
    get W51(): IACDCode {
        return this.FromId(404);
    }
    /**
		Returns W52 ACDCode
	**/
    get W52(): IACDCode {
        return this.FromId(405);
    }
    /**
		Returns W60 ACDCode
	**/
    get W60(): IACDCode {
        return this.FromId(406);
    }
    /**
		Returns W61 ACDCode
	**/
    get W61(): IACDCode {
        return this.FromId(407);
    }
    /**
		Returns W70 ACDCode
	**/
    get W70(): IACDCode {
        return this.FromId(408);
    }
    /**
		Returns W72 ACDCode
	**/
    get W72(): IACDCode {
        return this.FromId(409);
    }
    /**
		Returns W80 ACDCode
	**/
    get W80(): IACDCode {
        return this.FromId(410);
    }
    /**
		Returns W81 ACDCode
	**/
    get W81(): IACDCode {
        return this.FromId(411);
    }
    /**
		Returns W82 ACDCode
	**/
    get W82(): IACDCode {
        return this.FromId(412);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'A04', displayValue: 'A04', description: 'Driving under the influence of alcohol with BAC of at least .04 but not greater than .079', sortOrder: 999, active: true });
        this._dictionary.add('2', { id: 2, value: 'A08', displayValue: 'A08', description: 'Driving under the influence of alcohol with BAC at or over .08', sortOrder: 999, active: true });
        this._dictionary.add('3', { id: 3, value: 'A10', displayValue: 'A10', description: 'Driving under the influence of alcohol with BAC at or over .10', sortOrder: 999, active: true });
        this._dictionary.add('4', { id: 4, value: 'A11', displayValue: 'A11', description: 'Driving under the influence of alcohol with BAC at  __ (detail field required)', sortOrder: 999, active: true });
        this._dictionary.add('5', { id: 5, value: 'A12', displayValue: 'A12', description: 'Refused to submit to test for alcohol - Implied Consent Law', sortOrder: 999, active: true });
        this._dictionary.add('6', { id: 6, value: 'A20', displayValue: 'A20', description: 'Driving under the influence of alcohol or drugs', sortOrder: 999, active: true });
        this._dictionary.add('7', { id: 7, value: 'A21', displayValue: 'A21', description: 'Driving under the influence of alcohol', sortOrder: 999, active: true });
        this._dictionary.add('8', { id: 8, value: 'A22', displayValue: 'A22', description: 'Driving under the influence of drugs', sortOrder: 999, active: true });
        this._dictionary.add('9', { id: 9, value: 'A23', displayValue: 'A23', description: 'Driving under the influence of alcohol and drugs', sortOrder: 999, active: true });
        this._dictionary.add('10', { id: 10, value: 'A24', displayValue: 'A24', description: 'Driving under the influence of medication not intended to intoxicate', sortOrder: 999, active: true });
        this._dictionary.add('11', { id: 11, value: 'A25', displayValue: 'A25', description: 'Driving while impaired', sortOrder: 999, active: true });
        this._dictionary.add('12', { id: 12, value: 'A26', displayValue: 'A26', description: 'Drinking alcohol while operating a vehicle', sortOrder: 999, active: true });
        this._dictionary.add('13', { id: 13, value: 'A27', displayValue: 'A27', description: 'Driving after drinking - level of intoxication or impairment not known', sortOrder: 999, active: false });
        this._dictionary.add('14', { id: 14, value: 'A30', displayValue: 'A30', description: 'Possession', sortOrder: 999, active: false });
        this._dictionary.add('15', { id: 15, value: 'A31', displayValue: 'A31', description: 'Illegal possession of alcohol', sortOrder: 999, active: true });
        this._dictionary.add('16', { id: 16, value: 'A32', displayValue: 'A32', description: 'Illegal possession of alcohol or drugs', sortOrder: 999, active: false });
        this._dictionary.add('17', { id: 17, value: 'A33', displayValue: 'A33', description: 'Illegal possession of drugs (controlled substances)', sortOrder: 999, active: true });
        this._dictionary.add('18', { id: 18, value: 'A34', displayValue: 'A34', description: 'Illegal possession of weapon including firearm', sortOrder: 999, active: false });
        this._dictionary.add('19', { id: 19, value: 'A35', displayValue: 'A35', description: 'Possession of open alcohol container', sortOrder: 999, active: true });
        this._dictionary.add('20', { id: 20, value: 'A40', displayValue: 'A40', description: 'Aiding in violation of ignition interlock or immobilization device', sortOrder: 999, active: false });
        this._dictionary.add('21', { id: 21, value: 'A41', displayValue: 'A41', description: 'Driver violation of ignition interlock or immobilization device', sortOrder: 999, active: true });
        this._dictionary.add('22', { id: 22, value: 'A50', displayValue: 'A50', description: 'Motor vehicle used in the commission of a felony involving manufacturing, distributing, or dispensing a controlled substance', sortOrder: 999, active: true });
        this._dictionary.add('23', { id: 23, value: 'A51', displayValue: 'A51', description: 'Transporting liquor illegally', sortOrder: 999, active: false });
        this._dictionary.add('24', { id: 24, value: 'A52', displayValue: 'A52', description: 'Transporting liquor to a minor', sortOrder: 999, active: false });
        this._dictionary.add('25', { id: 25, value: 'A60', displayValue: 'A60', description: 'Underage Convicted of drinking and driving at .02 or higher BAC', sortOrder: 999, active: true });
        this._dictionary.add('26', { id: 26, value: 'A61', displayValue: 'A61', description: 'Underage Administrative Per Se - drinking and driving at .02 or higher BAC', sortOrder: 999, active: true });
        this._dictionary.add('27', { id: 27, value: 'A90', displayValue: 'A90', description: 'Administrative per se for BAC at or over .10', sortOrder: 999, active: true });
        this._dictionary.add('28', { id: 28, value: 'A91', displayValue: 'A91', description: 'Administrative per se for BAC at __ (detail field required)', sortOrder: 999, active: true });
        this._dictionary.add('29', { id: 29, value: 'A94', displayValue: 'A94', description: 'Administrative per se for BAC of at least .04 but not greater than .079', sortOrder: 999, active: true });
        this._dictionary.add('30', { id: 30, value: 'A98', displayValue: 'A98', description: 'Administrative per se for BAC at or over .08', sortOrder: 999, active: true });
        this._dictionary.add('31', { id: 31, value: 'B01', displayValue: 'B01', description: 'Hit and run - failure to stop and render aid after accident', sortOrder: 999, active: true });
        this._dictionary.add('32', { id: 32, value: 'B02', displayValue: 'B02', description: 'Hit and run - failure to stop and render aid after accident - Fatal accident', sortOrder: 999, active: true });
        this._dictionary.add('33', { id: 33, value: 'B03', displayValue: 'B03', description: 'Hit and run - failure to stop and render aid after accident - Personal injury accident', sortOrder: 999, active: true });
        this._dictionary.add('34', { id: 34, value: 'B04', displayValue: 'B04', description: 'Hit and run - failure to stop and render aid after accident - Property damage accident', sortOrder: 999, active: true });
        this._dictionary.add('35', { id: 35, value: 'B05', displayValue: 'B05', description: 'Leaving accident scene before police arrive', sortOrder: 999, active: true });
        this._dictionary.add('36', { id: 36, value: 'B06', displayValue: 'B06', description: 'Leaving accident scene before police arrive - Fatal accident', sortOrder: 999, active: true });
        this._dictionary.add('37', { id: 37, value: 'B07', displayValue: 'B07', description: 'Leaving accident scene before police arrive - Personal injury accident', sortOrder: 999, active: true });
        this._dictionary.add('38', { id: 38, value: 'B08', displayValue: 'B08', description: 'Leaving accident scene before police arrive - Property damage accident', sortOrder: 999, active: true });
        this._dictionary.add('39', { id: 39, value: 'B09', displayValue: 'B09', description: 'Refusal to reveal identity after accident', sortOrder: 999, active: false });
        this._dictionary.add('40', { id: 40, value: 'B10', displayValue: 'B10', description: 'Refusal to reveal identity after accident - Fatal accident', sortOrder: 999, active: false });
        this._dictionary.add('41', { id: 41, value: 'B11', displayValue: 'B11', description: 'Refusal to reveal identity after accident - Personal injury accident', sortOrder: 999, active: false });
        this._dictionary.add('42', { id: 42, value: 'B12', displayValue: 'B12', description: 'Refusal to reveal identity after accident - Property damage accident', sortOrder: 999, active: false });
        this._dictionary.add('43', { id: 43, value: 'B13', displayValue: 'B13', description: 'Failure of duties upon damaging unattended vehicle or injuring animal', sortOrder: 999, active: false });
        this._dictionary.add('44', { id: 44, value: 'B14', displayValue: 'B14', description: 'Failure to reveal identity after fatal or personal injury accident', sortOrder: 999, active: true });
        this._dictionary.add('45', { id: 45, value: 'B19', displayValue: 'B19', description: 'Driving while out of service order is in effect and operating a vehicle designed to transport 16 or more passengers, including the driver and/or transporting hazardous materials that require a placard', sortOrder: 999, active: true });
        this._dictionary.add('46', { id: 46, value: 'B20', displayValue: 'B20', description: 'Driving while license withdrawn', sortOrder: 999, active: true });
        this._dictionary.add('47', { id: 47, value: 'B21', displayValue: 'B21', description: 'Driving while license barred', sortOrder: 999, active: true });
        this._dictionary.add('48', { id: 48, value: 'B22', displayValue: 'B22', description: 'Driving while license canceled', sortOrder: 999, active: true });
        this._dictionary.add('49', { id: 49, value: 'B23', displayValue: 'B23', description: 'Driving while license denied', sortOrder: 999, active: true });
        this._dictionary.add('50', { id: 50, value: 'B24', displayValue: 'B24', description: 'Driving while license disqualified', sortOrder: 999, active: true });
        this._dictionary.add('51', { id: 51, value: 'B25', displayValue: 'B25', description: 'Driving while license revoked', sortOrder: 999, active: true });
        this._dictionary.add('52', { id: 52, value: 'B26', displayValue: 'B26', description: 'Driving while license suspended', sortOrder: 999, active: true });
        this._dictionary.add('53', { id: 53, value: 'B27', displayValue: 'B27', description: 'General driving while out of service order is in effect (for violations not covered by B19)', sortOrder: 999, active: true });
        this._dictionary.add('54', { id: 54, value: 'B28', displayValue: 'B28', description: 'Driving while registration canceled', sortOrder: 999, active: false });
        this._dictionary.add('55', { id: 55, value: 'B29', displayValue: 'B29', description: 'Driving while registration suspended', sortOrder: 999, active: false });
        this._dictionary.add('56', { id: 56, value: 'B30', displayValue: 'B30', description: 'Permit unlicensed person to drive', sortOrder: 999, active: false });
        this._dictionary.add('57', { id: 57, value: 'B40', displayValue: 'B40', description: 'Possess or provide counterfeit or altered document', sortOrder: 999, active: false });
        this._dictionary.add('58', { id: 58, value: 'B41', displayValue: 'B41', description: 'Possess or provide counterfeit or altered driver license (includes DL, CDL, and Instruction Permit) or ID', sortOrder: 999, active: true });
        this._dictionary.add('59', { id: 59, value: 'B42', displayValue: 'B42', description: 'Possess or provide counterfeit or altered registration or title', sortOrder: 999, active: false });
        this._dictionary.add('60', { id: 60, value: 'B43', displayValue: 'B43', description: 'Missing, defaced, or obscured license plates', sortOrder: 999, active: false });
        this._dictionary.add('61', { id: 61, value: 'B44', displayValue: 'B44', description: 'Mutilated document', sortOrder: 999, active: false });
        this._dictionary.add('62', { id: 62, value: 'B45', displayValue: 'B45', description: 'Mutilated driver license (includes DL, CDL, and Instruction Permit) or ID', sortOrder: 999, active: false });
        this._dictionary.add('63', { id: 63, value: 'B46', displayValue: 'B46', description: 'Mutilated registration card or title', sortOrder: 999, active: false });
        this._dictionary.add('64', { id: 64, value: 'B50', displayValue: 'B50', description: 'Expired or no document (or item) which is required', sortOrder: 999, active: false });
        this._dictionary.add('65', { id: 65, value: 'B51', displayValue: 'B51', description: 'Expired or no driver license (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: true });
        this._dictionary.add('66', { id: 66, value: 'B52', displayValue: 'B52', description: 'Expired or no emissions inspection', sortOrder: 999, active: false });
        this._dictionary.add('67', { id: 67, value: 'B53', displayValue: 'B53', description: 'Expired or no license plates or decal/sticker', sortOrder: 999, active: false });
        this._dictionary.add('68', { id: 68, value: 'B54', displayValue: 'B54', description: 'Expired or no registration or title', sortOrder: 999, active: false });
        this._dictionary.add('69', { id: 69, value: 'B55', displayValue: 'B55', description: 'Expired or no vehicle safety inspection', sortOrder: 999, active: false });
        this._dictionary.add('70', { id: 70, value: 'B56', displayValue: 'B56', description: 'Driving a CMV without obtaining a CDL', sortOrder: 999, active: true });
        this._dictionary.add('71', { id: 71, value: 'B57', displayValue: 'B57', description: 'Driving a CMV without a CDL in the drivers possession', sortOrder: 999, active: true });
        this._dictionary.add('72', { id: 72, value: 'B60', displayValue: 'B60', description: 'Failed to file document or report as required', sortOrder: 999, active: false });
        this._dictionary.add('73', { id: 73, value: 'B61', displayValue: 'B61', description: 'Failed to file accident report', sortOrder: 999, active: true });
        this._dictionary.add('74', { id: 74, value: 'B62', displayValue: 'B62', description: 'Failed to file change of address or name', sortOrder: 999, active: false });
        this._dictionary.add('75', { id: 75, value: 'B63', displayValue: 'B63', description: 'Failed to file future proof of financial responsibility', sortOrder: 999, active: true });
        this._dictionary.add('76', { id: 76, value: 'B64', displayValue: 'B64', description: 'Failed to file insurance certification', sortOrder: 999, active: true });
        this._dictionary.add('77', { id: 77, value: 'B65', displayValue: 'B65', description: 'Failed to file medical certification/disability information', sortOrder: 999, active: true });
        this._dictionary.add('78', { id: 78, value: 'B70', displayValue: 'B70', description: 'Failed to show document as required', sortOrder: 999, active: false });
        this._dictionary.add('79', { id: 79, value: 'B71', displayValue: 'B71', description: 'Failed to show certificate of weight', sortOrder: 999, active: false });
        this._dictionary.add('80', { id: 80, value: 'B72', displayValue: 'B72', description: 'Failed to show driver license (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: false });
        this._dictionary.add('81', { id: 81, value: 'B73', displayValue: 'B73', description: 'Failed to show emissions or vehicle (safety) inspection', sortOrder: 999, active: false });
        this._dictionary.add('82', { id: 82, value: 'B74', displayValue: 'B74', description: 'Failed to show insurance certification', sortOrder: 999, active: true });
        this._dictionary.add('83', { id: 83, value: 'B75', displayValue: 'B75', description: 'Failed to show operator\'s (driver\'s) log', sortOrder: 999, active: false });
        this._dictionary.add('84', { id: 84, value: 'B76', displayValue: 'B76', description: 'Failed to show registration', sortOrder: 999, active: false });
        this._dictionary.add('85', { id: 85, value: 'B77', displayValue: 'B77', description: 'Failed to show registration, title or driver license (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: false });
        this._dictionary.add('86', { id: 86, value: 'B78', displayValue: 'B78', description: 'Failed to show non-commercial driver license (includes Instruction Permit)', sortOrder: 999, active: true });
        this._dictionary.add('87', { id: 87, value: 'B80', displayValue: 'B80', description: 'Failed to surrender driver license (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: false });
        this._dictionary.add('88', { id: 88, value: 'B81', displayValue: 'B81', description: 'Failed to surrender driver license, registration, plates, or title', sortOrder: 999, active: false });
        this._dictionary.add('89', { id: 89, value: 'B82', displayValue: 'B82', description: 'Failed to surrender registration, plates, or title', sortOrder: 999, active: false });
        this._dictionary.add('90', { id: 90, value: 'B83', displayValue: 'B83', description: 'False report', sortOrder: 999, active: false });
        this._dictionary.add('91', { id: 91, value: 'B84', displayValue: 'B84', description: 'False report of accident', sortOrder: 999, active: false });
        this._dictionary.add('92', { id: 92, value: 'B85', displayValue: 'B85', description: 'False report of emissions inspection', sortOrder: 999, active: false });
        this._dictionary.add('93', { id: 93, value: 'B86', displayValue: 'B86', description: 'False report of odometer reading or disclosure', sortOrder: 999, active: false });
        this._dictionary.add('94', { id: 94, value: 'B87', displayValue: 'B87', description: 'False report of Operator\'s (driver\'s) log', sortOrder: 999, active: false });
        this._dictionary.add('95', { id: 95, value: 'B88', displayValue: 'B88', description: 'False report of theft', sortOrder: 999, active: false });
        this._dictionary.add('96', { id: 96, value: 'B89', displayValue: 'B89', description: 'False report of vehicle (safety) inspection', sortOrder: 999, active: false });
        this._dictionary.add('97', { id: 97, value: 'B90', displayValue: 'B90', description: 'Failed to provide or submit title transfer documents', sortOrder: 999, active: false });
        this._dictionary.add('98', { id: 98, value: 'B91', displayValue: 'B91', description: 'Improper classification or endorsement on driver license (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: true });
        this._dictionary.add('99', { id: 99, value: 'B92', displayValue: 'B92', description: 'Loan driver license (includes DL, CDL, and Instruction Permit) to another person', sortOrder: 999, active: false });
        this._dictionary.add('100', { id: 100, value: 'B93', displayValue: 'B93', description: 'Loan registration or plates to another person', sortOrder: 999, active: false });
        this._dictionary.add('101', { id: 101, value: 'D01', displayValue: 'D01', description: 'Misrepresentation of identity or other facts', sortOrder: 999, active: false });
        this._dictionary.add('102', { id: 102, value: 'D02', displayValue: 'D02', description: 'Misrepresentation of identity or other facts on application, including required self-certifications, for non-commercial permit or license', sortOrder: 999, active: true });
        this._dictionary.add('103', { id: 103, value: 'D03', displayValue: 'D03', description: 'Misrepresentation of identity or other facts on application for handicap permit/plates', sortOrder: 999, active: false });
        this._dictionary.add('104', { id: 104, value: 'D04', displayValue: 'D04', description: 'Misrepresentation of identity or other facts on application for registration or title', sortOrder: 999, active: false });
        this._dictionary.add('105', { id: 105, value: 'D05', displayValue: 'D05', description: 'Misrepresentation of identity or other facts to avoid arrest or prosecution', sortOrder: 999, active: false });
        this._dictionary.add('106', { id: 106, value: 'D06', displayValue: 'D06', description: 'Misrepresentation of identity or other facts to obtain alcohol', sortOrder: 999, active: true });
        this._dictionary.add('107', { id: 107, value: 'D07', displayValue: 'D07', description: 'Possess multiple driver licenses (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: true });
        this._dictionary.add('108', { id: 108, value: 'D10', displayValue: 'D10', description: 'Manufacture or make false driver license (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: true });
        this._dictionary.add('109', { id: 109, value: 'D11', displayValue: 'D11', description: 'Manufacture or make false emissions or vehicle (safety) inspection certificates', sortOrder: 999, active: false });
        this._dictionary.add('110', { id: 110, value: 'D12', displayValue: 'D12', description: 'Manufacture or make false registration or title', sortOrder: 999, active: false });
        this._dictionary.add('111', { id: 111, value: 'D15', displayValue: 'D15', description: 'Show or use improperly - Document (or item) not specified', sortOrder: 999, active: false });
        this._dictionary.add('112', { id: 112, value: 'D16', displayValue: 'D16', description: 'Show or use improperly - Driver License (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: true });
        this._dictionary.add('113', { id: 113, value: 'D17', displayValue: 'D17', description: 'Show or use improperly - Emissions or vehicle (safety) inspection', sortOrder: 999, active: false });
        this._dictionary.add('114', { id: 114, value: 'D18', displayValue: 'D18', description: 'Show or use improperly - Insurance certification', sortOrder: 999, active: false });
        this._dictionary.add('115', { id: 115, value: 'D19', displayValue: 'D19', description: 'Show or use improperly - Operator\'s (driver\'s) log', sortOrder: 999, active: false });
        this._dictionary.add('116', { id: 116, value: 'D20', displayValue: 'D20', description: 'Show or use improperly - Registration, plates, or decal/sticker', sortOrder: 999, active: false });
        this._dictionary.add('117', { id: 117, value: 'D21', displayValue: 'D21', description: 'Show or use improperly - Registration or title', sortOrder: 999, active: false });
        this._dictionary.add('118', { id: 118, value: 'D25', displayValue: 'D25', description: 'Use another\'s driver license (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: false });
        this._dictionary.add('119', { id: 119, value: 'D26', displayValue: 'D26', description: 'Use another\'s registration, plates, or title', sortOrder: 999, active: false });
        this._dictionary.add('120', { id: 120, value: 'D27', displayValue: 'D27', description: 'Violate limited license conditions', sortOrder: 999, active: true });
        this._dictionary.add('121', { id: 121, value: 'D28', displayValue: 'D28', description: 'Violate limits of registration (manufacturer, transporter, dealer, farm, antique, etc.)', sortOrder: 999, active: false });
        this._dictionary.add('122', { id: 122, value: 'D29', displayValue: 'D29', description: 'Violate restriction of drivers license (includes DL, CDL, and Instruction Permit)', sortOrder: 999, active: true });
        this._dictionary.add('123', { id: 123, value: 'D30', displayValue: 'D30', description: 'Misrepresentation of identity or other facts on application, including required self-certifications, for CLP or CDL', sortOrder: 999, active: true });
        this._dictionary.add('124', { id: 124, value: 'D31', displayValue: 'D31', description: 'Fraud related to the issuance of a CLP or CDL', sortOrder: 999, active: true });
        this._dictionary.add('125', { id: 125, value: 'D35', displayValue: 'D35', description: 'Failure to comply with financial responsibility law', sortOrder: 999, active: true });
        this._dictionary.add('126', { id: 126, value: 'D36', displayValue: 'D36', description: 'Failure to maintain required liability insurance', sortOrder: 999, active: true });
        this._dictionary.add('127', { id: 127, value: 'D37', displayValue: 'D37', description: 'Failure to pay for damages or make installment payment', sortOrder: 999, active: true });
        this._dictionary.add('128', { id: 128, value: 'D38', displayValue: 'D38', description: 'Failure to post security or obtain release from liability', sortOrder: 999, active: true });
        this._dictionary.add('129', { id: 129, value: 'D39', displayValue: 'D39', description: 'Unsatisfied judgment', sortOrder: 999, active: true });
        this._dictionary.add('130', { id: 130, value: 'D40', displayValue: 'D40', description: 'Failure to appear', sortOrder: 999, active: false });
        this._dictionary.add('131', { id: 131, value: 'D41', displayValue: 'D41', description: 'Failure to appear for hearing or mandatory appearance', sortOrder: 999, active: false });
        this._dictionary.add('132', { id: 132, value: 'D42', displayValue: 'D42', description: 'Failure to appear for or complete department investigations', sortOrder: 999, active: false });
        this._dictionary.add('133', { id: 133, value: 'D43', displayValue: 'D43', description: 'Failure to appear for or complete exam/re-exam', sortOrder: 999, active: false });
        this._dictionary.add('134', { id: 134, value: 'D44', displayValue: 'D44', description: 'Failure to appear for or complete required courses', sortOrder: 999, active: false });
        this._dictionary.add('135', { id: 135, value: 'D45', displayValue: 'D45', description: 'Failure to appear for trial or court appearance (detail sometimes required)', sortOrder: 999, active: true });
        this._dictionary.add('136', { id: 136, value: 'D50', displayValue: 'D50', description: 'Failure to make required payment', sortOrder: 999, active: false });
        this._dictionary.add('137', { id: 137, value: 'D51', displayValue: 'D51', description: 'Failure to make required payment of child support', sortOrder: 999, active: true });
        this._dictionary.add('138', { id: 138, value: 'D52', displayValue: 'D52', description: 'Failure to make required payment of fee', sortOrder: 999, active: false });
        this._dictionary.add('139', { id: 139, value: 'D53', displayValue: 'D53', description: 'Failure to make required payment of fine and costs (detail sometimes required)', sortOrder: 999, active: true });
        this._dictionary.add('140', { id: 140, value: 'D54', displayValue: 'D54', description: 'Failure to make required payment of tax', sortOrder: 999, active: false });
        this._dictionary.add('141', { id: 141, value: 'D55', displayValue: 'D55', description: 'Failure to make required payment of toll', sortOrder: 999, active: false });
        this._dictionary.add('142', { id: 142, value: 'D56', displayValue: 'D56', description: 'Failure to answer a citation, pay fines, penalties and/or costs related to the original violation (detail sometimes required)', sortOrder: 999, active: true });
        this._dictionary.add('143', { id: 143, value: 'D65', displayValue: 'D65', description: 'Depositing harmful (including injurious and burning) substance on traffic way', sortOrder: 999, active: false });
        this._dictionary.add('144', { id: 144, value: 'D66', displayValue: 'D66', description: 'Failure to remove harmful substance from traffic way', sortOrder: 999, active: false });
        this._dictionary.add('145', { id: 145, value: 'D67', displayValue: 'D67', description: 'Littering from a motor vehicle', sortOrder: 999, active: false });
        this._dictionary.add('146', { id: 146, value: 'D68', displayValue: 'D68', description: 'Throwing from vehicle any harmful substance', sortOrder: 999, active: false });
        this._dictionary.add('147', { id: 147, value: 'D70', displayValue: 'D70', description: 'Driver\'s view obstructed', sortOrder: 999, active: true });
        this._dictionary.add('148', { id: 148, value: 'D71', displayValue: 'D71', description: 'Exceeding hours on duty limitations', sortOrder: 999, active: false });
        this._dictionary.add('149', { id: 149, value: 'D72', displayValue: 'D72', description: 'Inability to control vehicle', sortOrder: 999, active: true });
        this._dictionary.add('150', { id: 150, value: 'D73', displayValue: 'D73', description: 'Obscuring, tampering with, or illegally displaying traffic control devices, warning, or instructions', sortOrder: 999, active: false });
        this._dictionary.add('151', { id: 151, value: 'D74', displayValue: 'D74', description: 'Operating a motor vehicle improperly because of drowsiness', sortOrder: 999, active: true });
        this._dictionary.add('152', { id: 152, value: 'D75', displayValue: 'D75', description: 'Operating a motor vehicle improperly due to physical or mental disability', sortOrder: 999, active: true });
        this._dictionary.add('153', { id: 153, value: 'D76', displayValue: 'D76', description: 'Perjury', sortOrder: 999, active: false });
        this._dictionary.add('154', { id: 154, value: 'D77', displayValue: 'D77', description: 'Sex offense in a motor vehicle', sortOrder: 999, active: false });
        this._dictionary.add('155', { id: 155, value: 'D78', displayValue: 'D78', description: 'Perjury about the operation of a motor vehicle', sortOrder: 999, active: true });
        this._dictionary.add('156', { id: 156, value: 'E01', displayValue: 'E01', description: 'Operating without equipment as required by law', sortOrder: 999, active: true });
        this._dictionary.add('157', { id: 157, value: 'E02', displayValue: 'E02', description: 'Operating without brakes as required by law', sortOrder: 999, active: true });
        this._dictionary.add('158', { id: 158, value: 'E03', displayValue: 'E03', description: 'Operating without HAZMAT safety equipment as required by law', sortOrder: 999, active: true });
        this._dictionary.add('159', { id: 159, value: 'E04', displayValue: 'E04', description: 'Operating without HAZMAT placards/markings as required by law', sortOrder: 999, active: true });
        this._dictionary.add('160', { id: 160, value: 'E05', displayValue: 'E05', description: 'Operating without lights as required by law', sortOrder: 999, active: true });
        this._dictionary.add('161', { id: 161, value: 'E06', displayValue: 'E06', description: 'Operating without school bus equipment as required by law', sortOrder: 999, active: true });
        this._dictionary.add('162', { id: 162, value: 'E20', displayValue: 'E20', description: 'Use of equipment prohibited by law', sortOrder: 999, active: false });
        this._dictionary.add('163', { id: 163, value: 'E21', displayValue: 'E21', description: 'Use of colored lights and/or siren prohibited by law', sortOrder: 999, active: false });
        this._dictionary.add('164', { id: 164, value: 'E22', displayValue: 'E22', description: 'Use of emergency vehicle markings prohibited by law', sortOrder: 999, active: false });
        this._dictionary.add('165', { id: 165, value: 'E23', displayValue: 'E23', description: 'Use of radar or laser detector prohibited by law', sortOrder: 999, active: true });
        this._dictionary.add('166', { id: 166, value: 'E24', displayValue: 'E24', description: 'Use of vehicle lights prohibited by law', sortOrder: 999, active: false });
        this._dictionary.add('167', { id: 167, value: 'E30', displayValue: 'E30', description: 'Defective equipment', sortOrder: 999, active: false });
        this._dictionary.add('168', { id: 168, value: 'E31', displayValue: 'E31', description: 'Defective brakes', sortOrder: 999, active: false });
        this._dictionary.add('169', { id: 169, value: 'E32', displayValue: 'E32', description: 'Defective emissions control device', sortOrder: 999, active: false });
        this._dictionary.add('170', { id: 170, value: 'E33', displayValue: 'E33', description: 'Defective HAZMAT safety devices', sortOrder: 999, active: false });
        this._dictionary.add('171', { id: 171, value: 'E34', displayValue: 'E34', description: 'Defective lights', sortOrder: 999, active: false });
        this._dictionary.add('172', { id: 172, value: 'E35', displayValue: 'E35', description: 'Defective or noisy exhaust system or muffler', sortOrder: 999, active: false });
        this._dictionary.add('173', { id: 173, value: 'E36', displayValue: 'E36', description: 'Defective school bus equipment', sortOrder: 999, active: false });
        this._dictionary.add('174', { id: 174, value: 'E37', displayValue: 'E37', description: 'Defective tires', sortOrder: 999, active: false });
        this._dictionary.add('175', { id: 175, value: 'E50', displayValue: 'E50', description: 'Failure to use equipment as required', sortOrder: 999, active: true });
        this._dictionary.add('176', { id: 176, value: 'E51', displayValue: 'E51', description: 'Failure to use brakes', sortOrder: 999, active: true });
        this._dictionary.add('177', { id: 177, value: 'E52', displayValue: 'E52', description: 'Failure to use disabled vehicle lights, reflectors, or flares as required', sortOrder: 999, active: false });
        this._dictionary.add('178', { id: 178, value: 'E53', displayValue: 'E53', description: 'Failure to use HAZMAT safety devices as required', sortOrder: 999, active: true });
        this._dictionary.add('179', { id: 179, value: 'E54', displayValue: 'E54', description: 'Failure to use headlight dimmer as required', sortOrder: 999, active: true });
        this._dictionary.add('180', { id: 180, value: 'E55', displayValue: 'E55', description: 'Failure to use lights as required', sortOrder: 999, active: true });
        this._dictionary.add('181', { id: 181, value: 'E56', displayValue: 'E56', description: 'Failure to use school bus safety equipment as required', sortOrder: 999, active: true });
        this._dictionary.add('182', { id: 182, value: 'E57', displayValue: 'E57', description: 'Failure to use snow tires or chains as required', sortOrder: 999, active: true });
        this._dictionary.add('183', { id: 183, value: 'E70', displayValue: 'E70', description: 'Equipment used improperly or obstructed', sortOrder: 999, active: true });
        this._dictionary.add('184', { id: 184, value: 'E71', displayValue: 'E71', description: 'Brakes used improperly', sortOrder: 999, active: true });
        this._dictionary.add('185', { id: 185, value: 'E72', displayValue: 'E72', description: 'Emissions control device used improperly or obstructed', sortOrder: 999, active: false });
        this._dictionary.add('186', { id: 186, value: 'E73', displayValue: 'E73', description: 'Equipment used improperly - making excessive noise', sortOrder: 999, active: false });
        this._dictionary.add('187', { id: 187, value: 'E74', displayValue: 'E74', description: 'Exhaust system used improperly or obstructed', sortOrder: 999, active: false });
        this._dictionary.add('188', { id: 188, value: 'E80', displayValue: 'E80', description: 'Failure to correct defects after inspection failure or notice', sortOrder: 999, active: false });
        this._dictionary.add('189', { id: 189, value: 'F01', displayValue: 'F01', description: 'Safety equipment not used properly as required', sortOrder: 999, active: false });
        this._dictionary.add('190', { id: 190, value: 'F02', displayValue: 'F02', description: 'Child or youth restraint not used properly as required', sortOrder: 999, active: true });
        this._dictionary.add('191', { id: 191, value: 'F03', displayValue: 'F03', description: 'Motorcycle safety equipment not used properly as required', sortOrder: 999, active: true });
        this._dictionary.add('192', { id: 192, value: 'F04', displayValue: 'F04', description: 'Seat belt not used properly as required', sortOrder: 999, active: true });
        this._dictionary.add('193', { id: 193, value: 'F05', displayValue: 'F05', description: 'Carrying unsecured passengers in open area of vehicle', sortOrder: 999, active: true });
        this._dictionary.add('194', { id: 194, value: 'F06', displayValue: 'F06', description: 'Improper operation of or riding on a motorcycle', sortOrder: 999, active: true });
        this._dictionary.add('195', { id: 195, value: 'F10', displayValue: 'F10', description: 'Exceeding or violating size, weight, or passenger/cargo limits', sortOrder: 999, active: false });
        this._dictionary.add('196', { id: 196, value: 'F11', displayValue: 'F11', description: 'Exceeding or violating passenger or cargo limits of vehicle/truck', sortOrder: 999, active: false });
        this._dictionary.add('197', { id: 197, value: 'F12', displayValue: 'F12', description: 'Exceeding or violating size limits of vehicle/truck', sortOrder: 999, active: false });
        this._dictionary.add('198', { id: 198, value: 'F13', displayValue: 'F13', description: 'Exceeding or violating weight limits of vehicle/truck', sortOrder: 999, active: false });
        this._dictionary.add('199', { id: 199, value: 'F14', displayValue: 'F14', description: 'Exceeding or violating passenger or cargo limits of motorcycle', sortOrder: 999, active: false });
        this._dictionary.add('200', { id: 200, value: 'F15', displayValue: 'F15', description: 'Exceeding or violating size limits of road/bridge/tunnel', sortOrder: 999, active: false });
        this._dictionary.add('201', { id: 201, value: 'F16', displayValue: 'F16', description: 'Exceeding or violating weight limits of road/bridge/tunnel', sortOrder: 999, active: false });
        this._dictionary.add('202', { id: 202, value: 'F20', displayValue: 'F20', description: 'Failure to weigh vehicle or stop at weigh station', sortOrder: 999, active: false });
        this._dictionary.add('203', { id: 203, value: 'F21', displayValue: 'F21', description: 'No or improper trip permit', sortOrder: 999, active: false });
        this._dictionary.add('204', { id: 204, value: 'F22', displayValue: 'F22', description: 'No warning for projecting load', sortOrder: 999, active: false });
        this._dictionary.add('205', { id: 205, value: 'F23', displayValue: 'F23', description: 'Spilling, dragging, unsecured or unsafe load', sortOrder: 999, active: false });
        this._dictionary.add('206', { id: 206, value: 'F24', displayValue: 'F24', description: 'Violation of excess size/weight permit', sortOrder: 999, active: false });
        this._dictionary.add('207', { id: 207, value: 'F30', displayValue: 'F30', description: 'Failure to place red flags or flares', sortOrder: 999, active: false });
        this._dictionary.add('208', { id: 208, value: 'F31', displayValue: 'F31', description: 'Failure to set brake(s)', sortOrder: 999, active: false });
        this._dictionary.add('209', { id: 209, value: 'F32', displayValue: 'F32', description: 'Non emergency stop', sortOrder: 999, active: false });
        this._dictionary.add('210', { id: 210, value: 'F33', displayValue: 'F33', description: 'Parking in a handicap zone', sortOrder: 999, active: false });
        this._dictionary.add('211', { id: 211, value: 'F34', displayValue: 'F34', description: 'Stopping, standing, or parking: obstructing or impeding traffic', sortOrder: 999, active: true });
        this._dictionary.add('212', { id: 212, value: 'F35', displayValue: 'F35', description: 'Stopping, standing, or parking where prohibited or improper', sortOrder: 999, active: false });
        this._dictionary.add('213', { id: 213, value: 'F40', displayValue: 'F40', description: 'Improper vehicle used on roadway', sortOrder: 999, active: false });
        this._dictionary.add('214', { id: 214, value: 'F41', displayValue: 'F41', description: 'Operate or permit vehicle where prohibited or not authorized', sortOrder: 999, active: false });
        this._dictionary.add('215', { id: 215, value: 'F60', displayValue: 'F60', description: 'Abandoned vehicle', sortOrder: 999, active: false });
        this._dictionary.add('216', { id: 216, value: 'F61', displayValue: 'F61', description: 'Alteration of emissions control device', sortOrder: 999, active: false });
        this._dictionary.add('217', { id: 217, value: 'F62', displayValue: 'F62', description: 'Failed to get VIN', sortOrder: 999, active: false });
        this._dictionary.add('218', { id: 218, value: 'F63', displayValue: 'F63', description: 'Leaving vehicle unattended with engine running', sortOrder: 999, active: false });
        this._dictionary.add('219', { id: 219, value: 'F64', displayValue: 'F64', description: 'Opening vehicle door into moving traffic or while vehicle is in motion', sortOrder: 999, active: false });
        this._dictionary.add('220', { id: 220, value: 'F65', displayValue: 'F65', description: 'Towing or pushing vehicle improperly', sortOrder: 999, active: false });
        this._dictionary.add('221', { id: 221, value: 'F66', displayValue: 'F66', description: 'Unsafe condition of vehicle (no specified component)', sortOrder: 999, active: false });
        this._dictionary.add('222', { id: 222, value: 'M01', displayValue: 'M01', description: 'Failure to obey', sortOrder: 999, active: false });
        this._dictionary.add('223', { id: 223, value: 'M02', displayValue: 'M02', description: 'Failure to obey barrier', sortOrder: 999, active: true });
        this._dictionary.add('224', { id: 224, value: 'M03', displayValue: 'M03', description: 'Failure to obey construction or maintenance zone markers', sortOrder: 999, active: true });
        this._dictionary.add('225', { id: 225, value: 'M04', displayValue: 'M04', description: 'Failure to obey flagger', sortOrder: 999, active: true });
        this._dictionary.add('226', { id: 226, value: 'M05', displayValue: 'M05', description: 'Failure to obey lane markings or signal', sortOrder: 999, active: true });
        this._dictionary.add('227', { id: 227, value: 'M06', displayValue: 'M06', description: 'Failure to obey motor carrier rules/regulations', sortOrder: 999, active: false });
        this._dictionary.add('228', { id: 228, value: 'M07', displayValue: 'M07', description: 'Failure to obey pedestrian control device', sortOrder: 999, active: false });
        this._dictionary.add('229', { id: 229, value: 'M08', displayValue: 'M08', description: 'Failure to obey police or peace officer', sortOrder: 999, active: true });
        this._dictionary.add('230', { id: 230, value: 'M09', displayValue: 'M09', description: 'For all drivers, failure to obey railroad-highway grade crossing restrictions not specifically noted in other railroad-highway grade crossing related codes', sortOrder: 999, active: true });
        this._dictionary.add('231', { id: 231, value: 'M10', displayValue: 'M10', description: 'For all drivers, failure to obey a traffic control device or the directions of an enforcement official at a railroad-highway grade crossing', sortOrder: 999, active: true });
        this._dictionary.add('232', { id: 232, value: 'M11', displayValue: 'M11', description: 'Failure to obey restricted lane', sortOrder: 999, active: true });
        this._dictionary.add('233', { id: 233, value: 'M12', displayValue: 'M12', description: 'Failure to obey safety zone', sortOrder: 999, active: true });
        this._dictionary.add('234', { id: 234, value: 'M13', displayValue: 'M13', description: 'Failure to obey school crossing guard', sortOrder: 999, active: true });
        this._dictionary.add('235', { id: 235, value: 'M14', displayValue: 'M14', description: 'Failure to obey sign or traffic control device', sortOrder: 999, active: true });
        this._dictionary.add('236', { id: 236, value: 'M15', displayValue: 'M15', description: 'Failure to obey stop sign', sortOrder: 999, active: true });
        this._dictionary.add('237', { id: 237, value: 'M16', displayValue: 'M16', description: 'Failure to obey traffic signal or light', sortOrder: 999, active: true });
        this._dictionary.add('238', { id: 238, value: 'M17', displayValue: 'M17', description: 'Failure to obey traffic sign', sortOrder: 999, active: true });
        this._dictionary.add('239', { id: 239, value: 'M18', displayValue: 'M18', description: 'Failure to obey warning light or flasher', sortOrder: 999, active: true });
        this._dictionary.add('240', { id: 240, value: 'M19', displayValue: 'M19', description: 'Failure to obey yield sign', sortOrder: 999, active: true });
        this._dictionary.add('241', { id: 241, value: 'M20', displayValue: 'M20', description: 'For drivers not required to always stop, failure to slow down at a railroad-highway grade crossing and check that tracks are clear of approaching train', sortOrder: 999, active: true });
        this._dictionary.add('242', { id: 242, value: 'M21', displayValue: 'M21', description: 'For drivers not required to always stop, failure to stop before reaching tracks at a railroad-highway grade crossing when tracks are not clear', sortOrder: 999, active: true });
        this._dictionary.add('243', { id: 243, value: 'M22', displayValue: 'M22', description: 'For drivers who are always required to stop, failure to stop as required before driving onto railroad-highway grade crossing', sortOrder: 999, active: true });
        this._dictionary.add('244', { id: 244, value: 'M23', displayValue: 'M23', description: 'For all drivers, failing to have sufficient space to drive completely through the railroad-highway grade crossing without stopping', sortOrder: 999, active: true });
        this._dictionary.add('245', { id: 245, value: 'M24', displayValue: 'M24', description: 'For all drivers, failing to negotiate a railroad-highway grade crossing because of insufficient undercarriage clearance', sortOrder: 999, active: true });
        this._dictionary.add('246', { id: 246, value: 'M25', displayValue: 'M25', description: 'Failure to stop - basic rule at unsigned intersection or when entering roadway from private driveway, alley, etc.', sortOrder: 999, active: true });
        this._dictionary.add('247', { id: 247, value: 'M30', displayValue: 'M30', description: 'Following improperly', sortOrder: 999, active: true });
        this._dictionary.add('248', { id: 248, value: 'M31', displayValue: 'M31', description: 'Failure to leave sufficient distance for overtaking by other vehicles', sortOrder: 999, active: true });
        this._dictionary.add('249', { id: 249, value: 'M32', displayValue: 'M32', description: 'Following emergency vehicle unlawfully', sortOrder: 999, active: true });
        this._dictionary.add('250', { id: 250, value: 'M33', displayValue: 'M33', description: 'Following fire equipment unlawfully', sortOrder: 999, active: true });
        this._dictionary.add('251', { id: 251, value: 'M34', displayValue: 'M34', description: 'Following too closely', sortOrder: 999, active: true });
        this._dictionary.add('252', { id: 252, value: 'M40', displayValue: 'M40', description: 'Improper lane or location', sortOrder: 999, active: true });
        this._dictionary.add('253', { id: 253, value: 'M41', displayValue: 'M41', description: 'Failure to keep in proper lane', sortOrder: 999, active: true });
        this._dictionary.add('254', { id: 254, value: 'M42', displayValue: 'M42', description: 'Improper or erratic (unsafe) lane changes', sortOrder: 999, active: true });
        this._dictionary.add('255', { id: 255, value: 'M43', displayValue: 'M43', description: 'Ran off road', sortOrder: 999, active: true });
        this._dictionary.add('256', { id: 256, value: 'M44', displayValue: 'M44', description: 'Improper lane or location - crossover', sortOrder: 999, active: true });
        this._dictionary.add('257', { id: 257, value: 'M45', displayValue: 'M45', description: 'Improper lane or location - crosswalk', sortOrder: 999, active: true });
        this._dictionary.add('258', { id: 258, value: 'M46', displayValue: 'M46', description: 'Improper lane or location - entrance/exit ramp or way', sortOrder: 999, active: true });
        this._dictionary.add('259', { id: 259, value: 'M47', displayValue: 'M47', description: 'Improper lane or location - in bicycle lane', sortOrder: 999, active: true });
        this._dictionary.add('260', { id: 260, value: 'M48', displayValue: 'M48', description: 'Improper lane or location - in occupied lane', sortOrder: 999, active: true });
        this._dictionary.add('261', { id: 261, value: 'M49', displayValue: 'M49', description: 'Improper lane or location - in HOV or restricted lane', sortOrder: 999, active: true });
        this._dictionary.add('262', { id: 262, value: 'M50', displayValue: 'M50', description: 'Improper lane or location - limited access highway', sortOrder: 999, active: true });
        this._dictionary.add('263', { id: 263, value: 'M51', displayValue: 'M51', description: 'Improper lane or location - median', sortOrder: 999, active: true });
        this._dictionary.add('264', { id: 264, value: 'M52', displayValue: 'M52', description: 'Improper lane or location - not on National Network', sortOrder: 999, active: false });
        this._dictionary.add('265', { id: 265, value: 'M53', displayValue: 'M53', description: 'Improper lane or location - not on route authorized by permit', sortOrder: 999, active: false });
        this._dictionary.add('266', { id: 266, value: 'M54', displayValue: 'M54', description: 'Improper lane or location - not on truck route', sortOrder: 999, active: false });
        this._dictionary.add('267', { id: 267, value: 'M55', displayValue: 'M55', description: 'Improper lane or location - on rail or streetcar tracks', sortOrder: 999, active: true });
        this._dictionary.add('268', { id: 268, value: 'M56', displayValue: 'M56', description: 'Improper lane or location - on fire hose', sortOrder: 999, active: true });
        this._dictionary.add('269', { id: 269, value: 'M57', displayValue: 'M57', description: 'Improper lane or location - oncoming traffic lane', sortOrder: 999, active: true });
        this._dictionary.add('270', { id: 270, value: 'M58', displayValue: 'M58', description: 'Improper lane or location - road shoulder, ditch or sidewalk', sortOrder: 999, active: true });
        this._dictionary.add('271', { id: 271, value: 'M60', displayValue: 'M60', description: 'Improper lane or location - slower vehicle lane', sortOrder: 999, active: true });
        this._dictionary.add('272', { id: 272, value: 'M61', displayValue: 'M61', description: 'Improper lane or location - straddling center line(s)', sortOrder: 999, active: true });
        this._dictionary.add('273', { id: 273, value: 'M62', displayValue: 'M62', description: 'Improper lane or location - traveling in turn (or center) lane', sortOrder: 999, active: true });
        this._dictionary.add('274', { id: 274, value: 'M70', displayValue: 'M70', description: 'Improper passing', sortOrder: 999, active: true });
        this._dictionary.add('275', { id: 275, value: 'M71', displayValue: 'M71', description: 'Passing in violation of posted sign or pavement marking', sortOrder: 999, active: true });
        this._dictionary.add('276', { id: 276, value: 'M72', displayValue: 'M72', description: 'Passing in violation of opposite directions restriction', sortOrder: 999, active: true });
        this._dictionary.add('277', { id: 277, value: 'M73', displayValue: 'M73', description: 'Passing on wrong side', sortOrder: 999, active: true });
        this._dictionary.add('278', { id: 278, value: 'M74', displayValue: 'M74', description: 'Passing on hill or curve', sortOrder: 999, active: true });
        this._dictionary.add('279', { id: 279, value: 'M75', displayValue: 'M75', description: 'Passing school bus displaying warning not to pass', sortOrder: 999, active: true });
        this._dictionary.add('280', { id: 280, value: 'M76', displayValue: 'M76', description: 'Passing where prohibited', sortOrder: 999, active: true });
        this._dictionary.add('281', { id: 281, value: 'M77', displayValue: 'M77', description: 'Passing with insufficient distance or visibility', sortOrder: 999, active: true });
        this._dictionary.add('282', { id: 282, value: 'M80', displayValue: 'M80', description: 'Inattentive/distracted, careless, or negligent driving', sortOrder: 999, active: true });
        this._dictionary.add('283', { id: 283, value: 'M81', displayValue: 'M81', description: 'Careless driving', sortOrder: 999, active: true });
        this._dictionary.add('284', { id: 284, value: 'M82', displayValue: 'M82', description: 'Inattentive/distracted driving', sortOrder: 999, active: true });
        this._dictionary.add('285', { id: 285, value: 'M83', displayValue: 'M83', description: 'Negligent driving', sortOrder: 999, active: true });
        this._dictionary.add('286', { id: 286, value: 'M84', displayValue: 'M84', description: 'Reckless driving', sortOrder: 999, active: true });
        this._dictionary.add('287', { id: 287, value: 'M85', displayValue: 'M85', description: 'Texting while driving', sortOrder: 999, active: true });
        this._dictionary.add('288', { id: 288, value: 'M86', displayValue: 'M86', description: 'Using a Hand Held Mobile Telephone while driving', sortOrder: 999, active: true });
        this._dictionary.add('289', { id: 289, value: 'N01', displayValue: 'N01', description: 'Failure to yield right of way (FTYROW)', sortOrder: 999, active: true });
        this._dictionary.add('290', { id: 290, value: 'N02', displayValue: 'N02', description: 'FTY ROW to animal rider or animal-drawn vehicle', sortOrder: 999, active: true });
        this._dictionary.add('291', { id: 291, value: 'N03', displayValue: 'N03', description: 'FTY ROW to cyclist', sortOrder: 999, active: true });
        this._dictionary.add('292', { id: 292, value: 'N04', displayValue: 'N04', description: 'FTY ROW to emergency vehicle (i.e. ambulance, fire equipment, police, etc.)', sortOrder: 999, active: true });
        this._dictionary.add('293', { id: 293, value: 'N05', displayValue: 'N05', description: 'FTY ROW to funeral procession, procession or parade', sortOrder: 999, active: true });
        this._dictionary.add('294', { id: 294, value: 'N06', displayValue: 'N06', description: 'FTY ROW to other vehicle', sortOrder: 999, active: true });
        this._dictionary.add('295', { id: 295, value: 'N07', displayValue: 'N07', description: 'FTY ROW to overtaking vehicle', sortOrder: 999, active: true });
        this._dictionary.add('296', { id: 296, value: 'N08', displayValue: 'N08', description: 'FTY ROW to pedestrian (includes handicapped or blind)', sortOrder: 999, active: true });
        this._dictionary.add('297', { id: 297, value: 'N09', displayValue: 'N09', description: 'FTY ROW to school bus', sortOrder: 999, active: true });
        this._dictionary.add('298', { id: 298, value: 'N20', displayValue: 'N20', description: 'FTY ROW at crosswalk', sortOrder: 999, active: true });
        this._dictionary.add('299', { id: 299, value: 'N21', displayValue: 'N21', description: 'FTY ROW at rotary/roundabout/circular intersection', sortOrder: 999, active: true });
        this._dictionary.add('300', { id: 300, value: 'N22', displayValue: 'N22', description: 'FTY ROW at stop sign', sortOrder: 999, active: true });
        this._dictionary.add('301', { id: 301, value: 'N23', displayValue: 'N23', description: 'FTY ROW at traffic sign', sortOrder: 999, active: true });
        this._dictionary.add('302', { id: 302, value: 'N24', displayValue: 'N24', description: 'FTY ROW at traffic signal', sortOrder: 999, active: true });
        this._dictionary.add('303', { id: 303, value: 'N25', displayValue: 'N25', description: 'FTY ROW at unsigned intersection', sortOrder: 999, active: true });
        this._dictionary.add('304', { id: 304, value: 'N26', displayValue: 'N26', description: 'FTY ROW at yield sign', sortOrder: 999, active: true });
        this._dictionary.add('305', { id: 305, value: 'N30', displayValue: 'N30', description: 'FTY ROW when warning displayed on other vehicle', sortOrder: 999, active: true });
        this._dictionary.add('306', { id: 306, value: 'N31', displayValue: 'N31', description: 'FTY ROW when turning', sortOrder: 999, active: true });
        this._dictionary.add('307', { id: 307, value: 'N40', displayValue: 'N40', description: 'Failure to use or improper signal', sortOrder: 999, active: true });
        this._dictionary.add('308', { id: 308, value: 'N41', displayValue: 'N41', description: 'Failure to cancel directional signals', sortOrder: 999, active: true });
        this._dictionary.add('309', { id: 309, value: 'N42', displayValue: 'N42', description: 'Failure to signal intention to pass', sortOrder: 999, active: true });
        this._dictionary.add('310', { id: 310, value: 'N43', displayValue: 'N43', description: 'Failure to signal lane change or turn', sortOrder: 999, active: true });
        this._dictionary.add('311', { id: 311, value: 'N44', displayValue: 'N44', description: 'Giving wrong signal', sortOrder: 999, active: true });
        this._dictionary.add('312', { id: 312, value: 'N50', displayValue: 'N50', description: 'Improper turn', sortOrder: 999, active: true });
        this._dictionary.add('313', { id: 313, value: 'N51', displayValue: 'N51', description: 'Improper method of turning', sortOrder: 999, active: true });
        this._dictionary.add('314', { id: 314, value: 'N52', displayValue: 'N52', description: 'Improper position for turning', sortOrder: 999, active: true });
        this._dictionary.add('315', { id: 315, value: 'N53', displayValue: 'N53', description: 'Making improper left turn', sortOrder: 999, active: true });
        this._dictionary.add('316', { id: 316, value: 'N54', displayValue: 'N54', description: 'Making improper right turn', sortOrder: 999, active: true });
        this._dictionary.add('317', { id: 317, value: 'N55', displayValue: 'N55', description: 'Making improper turn around (not U turn)', sortOrder: 999, active: true });
        this._dictionary.add('318', { id: 318, value: 'N56', displayValue: 'N56', description: 'Making improper U turn', sortOrder: 999, active: true });
        this._dictionary.add('319', { id: 319, value: 'N60', displayValue: 'N60', description: 'Driving wrong way', sortOrder: 999, active: true });
        this._dictionary.add('320', { id: 320, value: 'N61', displayValue: 'N61', description: 'Driving wrong way at rotary/roundabout/circular intersection', sortOrder: 999, active: true });
        this._dictionary.add('321', { id: 321, value: 'N62', displayValue: 'N62', description: 'Driving wrong way on divided highway', sortOrder: 999, active: true });
        this._dictionary.add('322', { id: 322, value: 'N63', displayValue: 'N63', description: 'Driving wrong way on one way street or road', sortOrder: 999, active: true });
        this._dictionary.add('323', { id: 323, value: 'N70', displayValue: 'N70', description: 'Driving on wrong side', sortOrder: 999, active: true });
        this._dictionary.add('324', { id: 324, value: 'N71', displayValue: 'N71', description: 'Driving on wrong side of divided highway', sortOrder: 999, active: true });
        this._dictionary.add('325', { id: 325, value: 'N72', displayValue: 'N72', description: 'Driving on wrong side of undivided street or road', sortOrder: 999, active: true });
        this._dictionary.add('326', { id: 326, value: 'N80', displayValue: 'N80', description: 'Coasting (operating with gears disengaged)', sortOrder: 999, active: true });
        this._dictionary.add('327', { id: 327, value: 'N81', displayValue: 'N81', description: 'Clinging to other vehicles', sortOrder: 999, active: false });
        this._dictionary.add('328', { id: 328, value: 'N82', displayValue: 'N82', description: 'Improper backing', sortOrder: 999, active: true });
        this._dictionary.add('329', { id: 329, value: 'N83', displayValue: 'N83', description: 'Improper starting from parked position', sortOrder: 999, active: true });
        this._dictionary.add('330', { id: 330, value: 'N84', displayValue: 'N84', description: 'Unsafe operation', sortOrder: 999, active: true });
        this._dictionary.add('331', { id: 331, value: 'R17', displayValue: 'R18', description: 'Accumulation of 2 RRGC Violations within 3 yrs ', sortOrder: 999, active: false });
        this._dictionary.add('332', { id: 332, value: 'S01', displayValue: 'S01', description: 'Speeding - 01-05 > Speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('333', { id: 333, value: 'S06', displayValue: 'S06', description: 'Speeding - 06-10 > Speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('334', { id: 334, value: 'S11', displayValue: 'S11', description: 'Speeding - 11-15 > Speed limit (detail required)', sortOrder: 999, active: false });
        this._dictionary.add('335', { id: 335, value: 'S14', displayValue: 'S14', description: 'Speeding - 11-14 > Speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('336', { id: 336, value: 'S15', displayValue: 'S15', description: 'Speeding 15 mph or more above speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('337', { id: 337, value: 'S16', displayValue: 'S16', description: 'Speeding - 16-20 > Speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('338', { id: 338, value: 'S21', displayValue: 'S21', description: 'Speeding - 21-25 > Speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('339', { id: 339, value: 'S26', displayValue: 'S26', description: 'Speeding - 26-30 > Speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('340', { id: 340, value: 'S31', displayValue: 'S31', description: 'Speeding - 31-35 > Speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('341', { id: 341, value: 'S36', displayValue: 'S36', description: 'Speeding - 36-40 > Speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('342', { id: 342, value: 'S41', displayValue: 'S41', description: 'Speeding - 41+ > Speed limit (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('343', { id: 343, value: 'S50', displayValue: 'S50', description: 'Speeding in a school zone (detail optional)', sortOrder: 999, active: false });
        this._dictionary.add('344', { id: 344, value: 'S51', displayValue: 'S51', description: 'Speeding - 01-10 > Speed limit (detail optional)', sortOrder: 999, active: true });
        this._dictionary.add('345', { id: 345, value: 'S61', displayValue: 'S61', description: 'Speeding - 11-20 > Speed limit (detail optional)', sortOrder: 999, active: false });
        this._dictionary.add('346', { id: 346, value: 'S71', displayValue: 'S71', description: 'Speeding - 21-30 > Speed limit (detail optional)', sortOrder: 999, active: true });
        this._dictionary.add('347', { id: 347, value: 'S81', displayValue: 'S81', description: 'Speeding - 31-40 > Speed limit (detail optional)', sortOrder: 999, active: true });
        this._dictionary.add('348', { id: 348, value: 'S91', displayValue: 'S91', description: 'Speeding - 41+ > Speed limit (detail optional)', sortOrder: 999, active: true });
        this._dictionary.add('349', { id: 349, value: 'S92', displayValue: 'S92', description: 'Speeding - Speed limit and actual speed (detail required)', sortOrder: 999, active: true });
        this._dictionary.add('350', { id: 350, value: 'S93', displayValue: 'S93', description: 'Speeding', sortOrder: 999, active: true });
        this._dictionary.add('351', { id: 351, value: 'S94', displayValue: 'S94', description: 'Prima Facie speed violation or driving too fast for conditions', sortOrder: 999, active: true });
        this._dictionary.add('352', { id: 352, value: 'S95', displayValue: 'S95', description: 'Speed contest (racing) on road open to traffic', sortOrder: 999, active: true });
        this._dictionary.add('353', { id: 353, value: 'S96', displayValue: 'S96', description: 'Speed less than minimum', sortOrder: 999, active: true });
        this._dictionary.add('354', { id: 354, value: 'S97', displayValue: 'S97', description: 'Operating at erratic or suddenly changing speeds', sortOrder: 999, active: true });
        this._dictionary.add('355', { id: 355, value: 'S98', displayValue: 'S98', description: 'Speeding on freeway (wasting fuel)', sortOrder: 999, active: true });
        this._dictionary.add('356', { id: 356, value: 'S99', displayValue: 'S99', description: 'Speeding in a school zone', sortOrder: 999, active: false });
        this._dictionary.add('357', { id: 357, value: 'U01', displayValue: 'U01', description: 'Fleeing or evading police or roadblock', sortOrder: 999, active: true });
        this._dictionary.add('358', { id: 358, value: 'U02', displayValue: 'U02', description: 'Resisting arrest', sortOrder: 999, active: true });
        this._dictionary.add('359', { id: 359, value: 'U03', displayValue: 'U03', description: 'Using a motor vehicle in connection with a felony (not traffic offense)', sortOrder: 999, active: true });
        this._dictionary.add('360', { id: 360, value: 'U04', displayValue: 'U04', description: 'Using a motor vehicle in connection with a misdemeanor (not traffic offense)', sortOrder: 999, active: true });
        this._dictionary.add('361', { id: 361, value: 'U05', displayValue: 'U05', description: 'Using a motor vehicle to aid and abet a felon', sortOrder: 999, active: true });
        this._dictionary.add('362', { id: 362, value: 'U06', displayValue: 'U06', description: 'Vehicular assault', sortOrder: 999, active: true });
        this._dictionary.add('363', { id: 363, value: 'U07', displayValue: 'U07', description: 'Vehicular homicide', sortOrder: 999, active: true });
        this._dictionary.add('364', { id: 364, value: 'U08', displayValue: 'U08', description: 'Vehicular manslaughter', sortOrder: 999, active: true });
        this._dictionary.add('365', { id: 365, value: 'U09', displayValue: 'U09', description: 'Negligent Homicide while operating a CMV', sortOrder: 999, active: true });
        this._dictionary.add('366', { id: 366, value: 'U10', displayValue: 'U10', description: 'Causing a fatality through negligent operation of a CMV', sortOrder: 999, active: true });
        this._dictionary.add('367', { id: 367, value: 'U20', displayValue: 'U20', description: 'Damaging or tampering with vehicle', sortOrder: 999, active: false });
        this._dictionary.add('368', { id: 368, value: 'U21', displayValue: 'U21', description: 'Illegal operation of emergency vehicle', sortOrder: 999, active: true });
        this._dictionary.add('369', { id: 369, value: 'U22', displayValue: 'U22', description: 'Odometer tampering', sortOrder: 999, active: false });
        this._dictionary.add('370', { id: 370, value: 'U23', displayValue: 'U23', description: 'Receiving or disposing of stolen vehicle or its parts', sortOrder: 999, active: false });
        this._dictionary.add('371', { id: 371, value: 'U24', displayValue: 'U24', description: 'Removal, falsification, or unauthorized use of VIN or registration plate', sortOrder: 999, active: false });
        this._dictionary.add('372', { id: 372, value: 'U25', displayValue: 'U25', description: 'Unauthorized use of a vehicle or taking a vehicle without owner consent', sortOrder: 999, active: false });
        this._dictionary.add('373', { id: 373, value: 'U26', displayValue: 'U26', description: 'Vehicle theft', sortOrder: 999, active: false });
        this._dictionary.add('374', { id: 374, value: 'U27', displayValue: 'U27', description: 'Vehicular Feticide (1st Degree)', sortOrder: 999, active: true });
        this._dictionary.add('375', { id: 375, value: 'U28', displayValue: 'U28', description: 'Vehicular Feticide (2nd Degree)', sortOrder: 999, active: true });
        this._dictionary.add('376', { id: 376, value: 'U30', displayValue: 'U30', description: 'Violation resulting in accident', sortOrder: 999, active: false });
        this._dictionary.add('377', { id: 377, value: 'U31', displayValue: 'U31', description: 'Violation resulting in fatal accident', sortOrder: 999, active: true });
        this._dictionary.add('378', { id: 378, value: 'U32', displayValue: 'U32', description: 'Violation resulting in personal injury accident', sortOrder: 999, active: false });
        this._dictionary.add('379', { id: 379, value: 'U33', displayValue: 'U33', description: 'Violation resulting in property damage accident', sortOrder: 999, active: false });
        this._dictionary.add('380', { id: 380, value: 'W00', displayValue: 'W00', description: 'Withdrawal, Non-ACD violation', sortOrder: 999, active: true });
        this._dictionary.add('381', { id: 381, value: 'W01', displayValue: 'W01', description: 'Accumulation of convictions (including point systems and/or being judged a habitual offender or violator)', sortOrder: 999, active: true });
        this._dictionary.add('382', { id: 382, value: 'W09', displayValue: 'W09', description: 'Failure to surrender HAZMAT endorsement as required by the USA Patriot Act', sortOrder: 999, active: true });
        this._dictionary.add('383', { id: 383, value: 'W10', displayValue: 'W10', description: 'Withdrawal (reason not specified)', sortOrder: 999, active: false });
        this._dictionary.add('384', { id: 384, value: 'W11', displayValue: 'W11', description: 'Family report recommended', sortOrder: 999, active: false });
        this._dictionary.add('385', { id: 385, value: 'W12', displayValue: 'W12', description: 'Immigration law offender', sortOrder: 999, active: false });
        this._dictionary.add('386', { id: 386, value: 'W13', displayValue: 'W13', description: 'Parental consent withdrawn', sortOrder: 999, active: true });
        this._dictionary.add('387', { id: 387, value: 'W14', displayValue: 'W14', description: 'Physical or mental disability', sortOrder: 999, active: true });
        this._dictionary.add('388', { id: 388, value: 'W15', displayValue: 'W15', description: 'Physicians\' or specialists\' report recommended', sortOrder: 999, active: true });
        this._dictionary.add('389', { id: 389, value: 'W20', displayValue: 'W20', description: 'Unable to pass DL test(s) or meet qualifications', sortOrder: 999, active: true });
        this._dictionary.add('390', { id: 390, value: 'W21', displayValue: 'W21', description: 'Unable to pass re-examination', sortOrder: 999, active: false });
        this._dictionary.add('391', { id: 391, value: 'W22', displayValue: 'W22', description: 'Under age for license', sortOrder: 999, active: false });
        this._dictionary.add('392', { id: 392, value: 'W23', displayValue: 'W23', description: 'Under age possession of tobacco', sortOrder: 999, active: false });
        this._dictionary.add('393', { id: 393, value: 'W24', displayValue: 'W24', description: 'Under age school dropout', sortOrder: 999, active: false });
        this._dictionary.add('394', { id: 394, value: 'W25', displayValue: 'W25', description: 'Disobeying terms of probation', sortOrder: 999, active: false });
        this._dictionary.add('395', { id: 395, value: 'W26', displayValue: 'W26', description: 'Insufficient funds, protested or invalid check', sortOrder: 999, active: false });
        this._dictionary.add('396', { id: 396, value: 'W27', displayValue: 'W27', description: 'Failure to make an appointment within 30 days of receiving notification that re-testing is necessary (when fraud is suspected', sortOrder: 999, active: true });
        this._dictionary.add('397', { id: 397, value: 'W28', displayValue: 'W28', description: 'Failure to retest or failure of scheduled test(s) (when fraud is suspected)', sortOrder: 999, active: true });
        this._dictionary.add('398', { id: 398, value: 'W30', displayValue: 'W30', description: 'Two convictions for serious violations within three years', sortOrder: 999, active: true });
        this._dictionary.add('399', { id: 399, value: 'W31', displayValue: 'W31', description: 'Three convictions for serious violations within three years', sortOrder: 999, active: true });
        this._dictionary.add('400', { id: 400, value: 'W40', displayValue: 'W40', description: 'The accumulation of two or more convictions for major offenses', sortOrder: 999, active: true });
        this._dictionary.add('401', { id: 401, value: 'W41', displayValue: 'W41', description: 'An additional conviction for a major offense after reinstatement', sortOrder: 999, active: true });
        this._dictionary.add('402', { id: 402, value: 'W45', displayValue: 'W45', description: 'Withdrawal for driving a CMV while disqualified for previous violation in a CMV', sortOrder: 999, active: true });
        this._dictionary.add('403', { id: 403, value: 'W50', displayValue: 'W50', description: 'The accumulation of two convictions for out-of-service order general violations (violations not covered by W51) within 10 years', sortOrder: 999, active: true });
        this._dictionary.add('404', { id: 404, value: 'W51', displayValue: 'W51', description: 'The accumulation of two convictions for out-of-service order violations within 10 years', sortOrder: 999, active: true });
        this._dictionary.add('405', { id: 405, value: 'W52', displayValue: 'W52', description: 'The accumulation of three or more convictions for out-of-service order violations within 10 years', sortOrder: 999, active: true });
        this._dictionary.add('406', { id: 406, value: 'W60', displayValue: 'W60', description: 'The accumulation of two convictions for RRGC violations within 3 years.', sortOrder: 999, active: true });
        this._dictionary.add('407', { id: 407, value: 'W61', displayValue: 'W61', description: 'The accumulation of three or more convictions for RRGC violations within 3 years.', sortOrder: 999, active: true });
        this._dictionary.add('408', { id: 408, value: 'W70', displayValue: 'W70', description: 'Imminent Hazard', sortOrder: 999, active: true });
        this._dictionary.add('409', { id: 409, value: 'W72', displayValue: 'W72', description: 'Suspended pending final disposition', sortOrder: 999, active: true });
        this._dictionary.add('410', { id: 410, value: 'W80', displayValue: 'W80', description: 'Failed employer-directed drug test', sortOrder: 999, active: true });
        this._dictionary.add('411', { id: 411, value: 'W81', displayValue: 'W81', description: 'Refusal to submit to an employer-directed drug test', sortOrder: 999, active: true });
        this._dictionary.add('412', { id: 412, value: 'W82', displayValue: 'W82', description: 'Failure to surrender license or permit or otherwise comply with jurisdiction requirements', sortOrder: 999, active: true });
        this._dictionary.add('414', { id: 414, value: 'U11', displayValue: 'U11', description: 'Using a CMV in the commission of severe forms of trafficking in persons', sortOrder: 999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IACDCode {
        return this._dictionary[id];
    }

    public FromValue(value: string): IACDCode {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IACDCode[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IACDCode[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IACDCode[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
